/* pg-product.js (v83) - skrypty Prime Gastro karty produktu, ładowane raz na szablonie
   product z atrybutem defer. Każda część to osobny IIFE i sama sprawdza, czy jej elementy
   są na stronie. Kolejność: ilość i przycisk koszyka, dobór akcesoriów, akordeony na
   telefonie, lepki pasek zakupu, pasek Akcesoria | Części zamienne, ostatnio oglądane (v84). */

/* ===== quantity-fix-primegastro.js ===== */
/**
 * QUANTITY INPUT FIX - primegastro.pl v2
 * 
 * IMPROVED: Handles disabled variant inputs
 * Aggressively finds variant ID from multiple sources
 */

(function() {
  'use strict';


  function init() {
    patchQuantityInput();
    setupClickHandler();
  }

  function patchQuantityInput() {
    if (!window.customElements) return;

    const checkInterval = setInterval(() => {
      const QuantityInput = customElements.get('quantity-input');
      
      if (QuantityInput) {
        clearInterval(checkInterval);
        
        const originalToggle = QuantityInput.prototype.toggleAddButton;

        QuantityInput.prototype.toggleAddButton = function(disable, text) {
          try {
            // Get product data
            const productData = getProductData();
            if (!productData) {
              return;
            }

            // Get variant ID - AGGRESSIVE approach for disabled inputs
            const form = this.closest('form') || document.querySelector('form[data-product-form]');
            const variantId = getVariantId(form);

            if (!variantId) {
              return;
            }


            // Find variant
            const currentVariant = productData.variants?.find(v => v.id == variantId);
            if (!currentVariant) {
              return;
            }

            // Get availability from multiple sources
            let isAvailable = true;

            // Source 1: variant.available (if exists)
            if (currentVariant.hasOwnProperty('available')) {
              isAvailable = currentVariant.available;
            } 
            // Source 2: data-settings
            else {
              const settings = getSettings(this);
              if (settings && settings.hasOwnProperty('data_available')) {
                isAvailable = settings.data_available !== false;
              }
              // Source 3: Global inventory
              else if (window.gwProductInventoryQuantity) {
                const qty = parseInt(window.gwProductInventoryQuantity[variantId]);
                isAvailable = !isNaN(qty) && qty > 0;
              }
            }

            // Update button
            const addButton = form?.querySelector('[name="add"], [type="submit"]');
            if (addButton) {
              if (!isAvailable) {
                addButton.disabled = true;
                setButtonText(addButton, text || addButton.dataset.unavailableText || 'Wyprzedane');
              } else {
                addButton.disabled = disable;
                setButtonText(addButton, addButton.dataset.defaultText || 'Dodaj do koszyka');
              }
            }

          } catch (error) {
            if (originalToggle) {
              try {
                originalToggle.call(this, disable, text);
              } catch (e) {}
            }
          }
        };

      }
    }, 100);

    setTimeout(() => clearInterval(checkInterval), 5000);
  }

  function setupClickHandler() {
    document.addEventListener('click', function(e) {
      const qtyButton = e.target.closest('.pm__quantity-button, [name="plus"], [name="minus"]');
      if (!qtyButton) return;

      setTimeout(() => {
        try {
          const quantityInput = qtyButton.closest('quantity-input');
          if (!quantityInput) return;

          const form = quantityInput.closest('form') || document.querySelector('form[data-product-form]');
          if (!form) return;

          const variantId = getVariantId(form);
          if (!variantId) return;

          const settings = getSettings(quantityInput);
          const isAvailable = settings?.data_available !== false;

          const addButton = form.querySelector('[name="add"], [type="submit"]');
          if (addButton) {
            if (!isAvailable) {
              addButton.disabled = true;
              setButtonText(addButton, addButton.dataset.unavailableText || 'Wyprzedane');
            } else {
              addButton.disabled = false;
              setButtonText(addButton, addButton.dataset.defaultText || 'Dodaj do koszyka');
            }
          }
        } catch (error) {
        }
      }, 50);
    }, true);

  }

  // IMPROVED: Aggressive variant ID detection
  function getVariantId(form) {
    if (!form) return null;

    const variantInput = form.querySelector('[name="id"]');
    if (!variantInput) return null;

    // Try multiple methods to get variant ID.
    // The property reflects runtime variant changes; the attribute can stay stale.
    if (variantInput.value && variantInput.value !== '') {
      return variantInput.value;
    }

    const attrValue = variantInput.getAttribute('value');
    if (attrValue && attrValue !== '') {
      return attrValue;
    }

    // 3. data-id attribute
    const dataId = variantInput.getAttribute('data-id') || variantInput.dataset.id;
    if (dataId) {
      return dataId;
    }

    // 4. From product data (single variant products)
    const productData = getProductData();
    if (productData?.variants?.length === 1) {
      const variantId = productData.variants[0].id;
      return variantId;
    }

    return null;
  }

  function getProductData() {
    if (window.ShopifyAnalytics?.meta?.product) {
      return window.ShopifyAnalytics.meta.product;
    }
    if (window.productData) {
      return window.productData;
    }
    if (window.product) {
      return window.product;
    }
    try {
      const productJson = document.querySelector('[data-product-json]');
      if (productJson) {
        return JSON.parse(productJson.textContent);
      }
    } catch (e) {}
    return null;
  }

  // v83: przycisk koszyka ma w środku ikonę i <span class="ButtonText">; wcześniej
  // textContent kasował ikonę i span (a z nim dopisek "(+N)" z doboru akcesoriów).
  function setButtonText(btn, txt) {
    const label = btn.querySelector('.ButtonText');
    if (label) { label.textContent = txt; } else { btn.textContent = txt; }
  }

  function getSettings(quantityInput) {
    try {
      const settingsAttr = quantityInput.getAttribute('data-settings');
      if (settingsAttr) {
        return JSON.parse(settingsAttr);
      }
    } catch (e) {}
    return null;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }



})();

;
/* ===== pdp-direct-accessories.js ===== */
/*
 * v77 UI: dobór akcesoriów na karcie produktu (snippets/pdp-direct-accessories.liquid).
 * Zaznaczone akcesoria dokładamy do koszyka JEDNYM żądaniem /cart/add.js tuż przed
 * głównym dodaniem produktu, a potem klikamy główny przycisk jeszcze raz, żeby motyw
 * dodał produkt własną ścieżką (spinner, zdarzenie product:added, otwarcie szuflady).
 * Etykieta przycisku dostaje "(+N)", pod listą pojawia się suma netto.
 *
 * 27.10.2026 przy zaznaczonym akcesorium
 * pole ilości z −/+. Startuje od ilości produktu i idzie za nią (pole formularza, przyciski −/+ motywu, pasek
 * przyklejony), dopóki klient sam go nie zmieni (wpis, −, +) – wtedy pozycja zostaje przy swojej liczbie
 * (atrybut data-pg-reczna="1" na polu). Do koszyka akcesoria idą z tymi ilościami, a `_Termin realizacji` to termin
 * zwykły akcesorium; od 28.10 stanu akcesorium nie ma w stronie, a termin ponad stan poprawia koszyk
 * (assets/pg-global.js, część „cart-lead”). Funkcja termin() zostaje z regułą „nadmiar” dla podanego stanu. Suma pod
 * przyciskiem liczy akcesorium razy jego ilość; napis przycisku dalej liczy pozycje, nie sztuki. Odpowiedź /cart/add.js
 * sprawdzamy (response.ok): przy błędzie komunikat przy bloku, a produkt dodaje się jak dotąd.
 * Czyste funkcje: window.__pgAddonsLogika pozycje do
 * koszyka: window.__pgAddonsPozycje() – z niej bierze je też „Kup teraz” (assets/pg-kup-teraz.js), więc obie drogi mają
 * te same ilości i terminy.
 */
(function () {
  if (window.__pgAddons) return;
  window.__pgAddons = true;

  /* 14.09 (zmiany-w-motywie.md pkt 13.1): suma netto i brutto; dopiski „netto”/„brutto” z pliku języka (data-net-suffix,
     data-gross-suffix na .pg-addons) – wcześniej na stałe „zł netto” także na /en */
  function formatAmount(cents, suffix) {
    var parts = (cents / 100).toFixed(2).split('.');
    return parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + ',' + parts[1] + ' zł ' + suffix;
  }

  /* ---------- 27.10 logika bez DOM ---------- */

  /* ilość: liczba całkowita, najmniej 1 (puste albo błędne pole daje 1) */
  function ilosc(v) {
    var n = parseInt(v, 10);
    return n >= 1 ? n : 1;
  }

  /* ilość pola akcesorium po zmianie ilości produktu: idzie za produktem, dopóki klient sam jej nie zmienił */
  function iloscZaProduktem(obecna, reczna, iloscProduktu) {
    return reczna ? ilosc(obecna) : ilosc(iloscProduktu);
  }

  /* tekst `_Termin realizacji`: „nadmiar”, gdy ilość > stan, stan podany (pole 5 z pg-availability – puste, gdy przypadek
     nie występuje) i tekst „nadmiar” inny niż zwykły; jak komunikat produktu (pg-ilosc-uwaga.liquid i część lead-qty niżej) */
  function termin(il, stan, zwykly, nadmiar) {
    var s = parseInt(stan, 10);
    if (s > 0 && nadmiar && nadmiar !== zwykly && ilosc(il) > s) return nadmiar;
    return zwykly || '';
  }

  /* pozycja do /cart/add.js; właściwości ustawiamy RAZ, przy dodaniu, nigdy osobnym żądaniem po dodaniu
     (pułapka 57: zmiana właściwości pozycji zmienia jej klucz) */
  function pozycja(d) {
    var it = { id: parseInt(d.id, 10), quantity: ilosc(d.ilosc) };
    var t = termin(d.ilosc, d.stan, d.zwykly, d.nadmiar);
    if (t) it.properties = { '_Termin realizacji': t };
    return it;
  }

  /* suma pod przyciskiem (grosze): brutto = cena × ilość; netto sumujemy z kwot netto POKAZANYCH przy pozycjach (każda
     zaokrąglona do grosza) razy ilość, żeby klient, który doda je sam, dostał tę samą liczbę – makieta R48:
     20 096,68 + 493,72 + 1 502,85 = 22 093,25 (z brutto/1,23 wychodziło ,24) */
  function sumy(cenaProduktu, iloscProduktu, akcesoria, vatDiv) {
    var q = ilosc(iloscProduktu);
    var wynik = { brutto: cenaProduktu * q, netto: Math.round(cenaProduktu / vatDiv) * q };
    akcesoria.forEach(function (a) {
      var n = ilosc(a.ilosc);
      wynik.brutto += a.cena * n;
      wynik.netto += Math.round(a.cena / vatDiv) * n;
    });
    return wynik;
  }

  /* jedno żądanie /cart/add.js dla akcesoriów (pułapka 70: Shopify dokłada pozycje na początek koszyka, produkt dochodzi
     po nich drugim kliknięciem głównego przycisku); obietnica daje true tylko przy odpowiedzi 2xx – do 27.10 odpowiedź
     4xx przechodziła bez komunikatu, a akcesoria cicho przepadały */
  function dodajAkcesoria(root, items) {
    return fetch(root + '/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      credentials: 'same-origin',
      body: JSON.stringify({ items: items })
    })
      .then(function (r) { return !!(r && r.ok); })
      .catch(function (err) { console.error('pg-addons: nie udało się dodać akcesoriów', err); return false; });
  }

  /* ---------- odczyt z karty ---------- */

  function poleIlosci(c) {
    var item = c.closest ? c.closest('.pg-addons__item') : null;
    return item ? item.querySelector('.pg-addons__qty-input') : null;
  }

  function daneAkcesorium(c) {
    var q = poleIlosci(c);
    return {
      id: c.getAttribute('data-variant-id'),
      cena: parseInt(c.getAttribute('data-price'), 10) || 0,
      ilosc: q ? q.value : 1,
      zwykly: c.getAttribute('data-lead-time') || ''
    };
  }

  /* pozycje zaznaczonych akcesoriów do /cart/add.js – „Dodaj do koszyka” niżej i „Kup teraz” (pg-kup-teraz.js) */
  function pozycjeAkcesoriow() {
    var lista = [];
    Array.prototype.forEach.call(document.querySelectorAll('[data-direct-accessories] .pg-addons__checkbox:checked'), function (c) {
      var p = pozycja(daneAkcesorium(c));
      if (p.id) lista.push(p);
    });
    return lista;
  }

  window.__pgAddonsLogika = { ilosc: ilosc, iloscZaProduktem: iloscZaProduktem, termin: termin, pozycja: pozycja, sumy: sumy, dodajAkcesoria: dodajAkcesoria };
  window.__pgAddonsPozycje = pozycjeAkcesoriow;

  function init() {
    var box = document.querySelector('[data-direct-accessories]');
    if (!box) return;
    var form = document.querySelector('form[data-product-form]');
    var mainBtn = form && form.querySelector('[data-action="add-to-cart"]');
    if (!form || !mainBtn) return;

    var label = mainBtn.querySelector('.ButtonText');
    var baseLabel = label ? label.textContent.trim() : '';
    var stickyLabel = document.querySelector('.pg-stickybar__button-text--long');
    var stickyBase = stickyLabel ? stickyLabel.textContent.trim() : '';
    /* S1 (makieta R48): suma stoi pod rzędem ilość + koszyk (blocks/_product-buy-buttons.liquid), nie pod listą */
    var summary = document.querySelector('[data-addons-summary]');
    var summaryLabel = box.getAttribute('data-summary-label') || '';
    var countFew = box.getAttribute('data-count-few') || '[count]';
    var countMany = box.getAttribute('data-count-many') || '[count]';
    var mainPrice = parseInt(box.getAttribute('data-main-price'), 10) || 0;
    var netSuffix = box.getAttribute('data-net-suffix') || 'netto';
    var grossSuffix = box.getAttribute('data-gross-suffix') || 'brutto';
    /* 27.10 komunikat, gdy koszyk odrzuci akcesoria (tekst z pliku języka, data-error) */
    var blad = box.querySelector('[data-addons-error]');
    var bladTekst = box.getAttribute('data-error') || '';

    /* pole ilości produktu szukamy przy każdym użyciu (27.10: motyw podmienia bloki przy zmianie wariantu) */
    function poleProduktu() {
      return form.querySelector('input[name="quantity"]') || document.querySelector('.pm__buttons-pay-quantity input[name="quantity"]');
    }

    function iloscProduktu() {
      var p = poleProduktu();
      return p ? ilosc(p.value) : 1;
    }

    function checked() {
      return Array.prototype.slice.call(box.querySelectorAll('.pg-addons__checkbox:checked'));
    }

    /* liczba produktów po polsku: 2–4, 22–24… „produkty”, pozostałe „produktów” (1 się nie zdarza – zawsze produkt + akcesorium) */
    function ileProduktow(n) {
      var d = n % 10, s = n % 100;
      var tpl = (d >= 2 && d <= 4 && (s < 12 || s > 14)) ? countFew : countMany;
      return tpl.replace('[count]', n);
    }

    /* 27.10: pola akcesoriów niezmienione ręcznie idą za ilością produktu (także ukryte – po zaznaczeniu pokażą bieżącą ilość) */
    function zaProduktem() {
      var p = poleProduktu();
      var n = p ? parseInt(p.value, 10) : 1;
      if (!(n >= 1)) return; /* pole produktu w trakcie wpisywania (puste) – akcesoria czekają na liczbę */
      Array.prototype.forEach.call(box.querySelectorAll('.pg-addons__qty-input'), function (q) {
        var v = String(iloscZaProduktem(q.value, q.getAttribute('data-pg-reczna') === '1', n));
        if (q.value !== v) q.value = v;
      });
    }

    /* 27.10: wiersz ilości widoczny tylko przy zaznaczonym akcesorium (zmiana po kliknięciu klienta nie liczy się do CLS) */
    function wierszeIlosci() {
      Array.prototype.forEach.call(box.querySelectorAll('.pg-addons__checkbox'), function (c) {
        var item = c.closest('.pg-addons__item');
        var w = item && item.querySelector('[data-addon-qty]');
        if (w) w.hidden = !c.checked;
      });
    }

    function update() {
      var list = checked();
      /* 20.09 (245, B81 a): stawka VAT z ustawienia motywu (`window.theme.vatDiv`, layout/theme.liquid) – jedno miejsce dla całego sklepu */
      var VAT_DIV = (window.theme && window.theme.vatDiv) || 1.23;
      /* przycisk: „Dodaj do koszyka (3 produkty)” – ten produkt + zaznaczone akcesoria; w wąskim pasku przyklejonym zostaje „(+N)” */
      if (label) label.textContent = list.length ? baseLabel + ' (' + ileProduktow(list.length + 1) + ')' : baseLabel;
      if (stickyLabel) stickyLabel.textContent = stickyBase + (list.length ? ' (+' + list.length + ')' : '');
      if (summary) {
        if (list.length) {
          /* 27.10 akcesorium razy jego ilość (dotąd zawsze 1 sztuka) */
          var suma = sumy(mainPrice, iloscProduktu(), list.map(daneAkcesorium), VAT_DIV);
          summary.innerHTML = '';
          var l = document.createElement('span'); l.textContent = summaryLabel;
          var k = document.createElement('span');
          var b = document.createElement('b'); b.textContent = formatAmount(suma.netto, netSuffix);
          k.appendChild(b); k.appendChild(document.createTextNode(' · ' + formatAmount(suma.brutto, grossSuffix)));
          summary.appendChild(l); summary.appendChild(k);
          summary.hidden = false;
        } else {
          summary.hidden = true;
        }
      }
    }

    function poZmianieProduktu() {
      zaProduktem();
      update();
    }

    box.addEventListener('change', function (e) {
      var t = e.target;
      if (!t || !t.classList) return;
      if (t.classList.contains('pg-addons__checkbox')) {
        zaProduktem();
        wierszeIlosci();
        update();
      } else if (t.classList.contains('pg-addons__qty-input')) {
        t.value = String(ilosc(t.value)); /* po wpisie: liczba całkowita, najmniej 1 */
        update();
      }
    });
    /* 27.10: wpis w polu akcesorium – od teraz ta pozycja zostaje przy swojej liczbie */
    box.addEventListener('input', function (e) {
      var t = e.target;
      if (t && t.classList && t.classList.contains('pg-addons__qty-input')) {
        t.setAttribute('data-pg-reczna', '1');
        update();
      }
    });
    /* 27.10: −/+ przy akcesorium (też zmiana ręczna) */
    box.addEventListener('click', function (e) {
      var b = e.target && e.target.closest ? e.target.closest('[data-addon-qty-step]') : null;
      if (!b) return;
      var w = b.closest('[data-addon-qty]');
      var q = w && w.querySelector('.pg-addons__qty-input');
      if (!q) return;
      q.value = String(ilosc(ilosc(q.value) + (parseInt(b.getAttribute('data-addon-qty-step'), 10) || 0)));
      q.setAttribute('data-pg-reczna', '1');
      update();
    });

    /* ilość produktu zmienia się na trzy sposoby: wpis w polu, przyciski −/+ motywu (bez zdarzeń – pułapka z v83) i pasek
       przyklejony (pushToMain wysyła input i change na tym samym polu); 27.10: nasłuch w fazie przechwytywania jak lead-qty
       i pasek (dotąd bąbelkowanie i 0 ms), a za ilością produktu idą też pola akcesoriów */
    document.addEventListener('input', function (e) {
      if (e.target && e.target === poleProduktu()) poZmianieProduktu();
    }, true);
    document.addEventListener('change', function (e) {
      if (e.target && e.target === poleProduktu()) poZmianieProduktu();
    }, true);
    document.addEventListener('click', function (e) {
      if (e.target && e.target.closest && e.target.closest('.pm__buttons-pay-quantity .pm__quantity-button')) setTimeout(poZmianieProduktu, 60);
    }, true);

    /* Faza przechwytywania: jesteśmy przed delegatem motywu na komponencie produktu. */
    mainBtn.addEventListener('click', function (e) {
      if (mainBtn.hasAttribute('data-addons-added')) {
        mainBtn.removeAttribute('data-addons-added');
        return;
      }
      /* 14.09 (zmiany-w-motywie.md pkt 13.4): termin realizacji akcesorium przy pozycji zamówienia; 27.10: z ilością i terminem „nadmiar” */
      var items = pozycjeAkcesoriow();
      if (!items.length) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      if (blad) { blad.hidden = true; blad.textContent = ''; }
      var root = (window.routes && window.routes.localeRootUrl) || '';
      dodajAkcesoria(root, items).then(function (ok) {
        /* 27.10: błąd – komunikat przy bloku (role="alert"); produkt i tak dodajemy jak dotąd */
        if (!ok && blad && bladTekst) {
          blad.textContent = bladTekst;
          blad.hidden = false;
        }
        mainBtn.setAttribute('data-addons-added', 'true');
        mainBtn.click();
      });
    }, true);

    zaProduktem();
    wierszeIlosci();
    update();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

;
/* ===== pdp-mobile-sections (v86) ===== */
/*
 * Telefon i tablet (<= 1023 px): OPIS i DANE TECHNICZNE wyglądają jak na desktopie - zwykłe
 * nagłówki bez tła, treść zawsze widoczna (polecenie użytkownika 13.09; v77 robiła tu akordeony
 * z szarym tłem). Motyw klonuje treść do pełnoekranowego okna w DesktopProductInfo, a nagłówek
 * ma pointer-events:none (main-product.css), więc okno się nie otwiera.
 * Zostaje tylko przycięcie DŁUGIEJ treści do 360 px z przyciskiem "Pokaż więcej" / "Pokaż mniej":
 * przycisk powstaje wyłącznie, gdy zmierzona pełna wysokość treści przekracza limit z zapasem
 * (zgłoszenie: przycisk pojawiał się też przy krótkiej treści i tylko zmieniał napis).
 * Zakres: tylko dropdowny z data-id (bloki _technical-info-dropdown); "Instrukcje do pobrania"
 * ma własny natywny toggle motywu i zostaje bez zmian.
 */
(function () {
  if (window.__pgPdpSections) return;
  window.__pgPdpSections = true;

  var mq = window.matchMedia('(max-width: 1023px)');
  var CLAMP = 360;
  var SLACK = 80;
  var SEL_DD = '#product-info .Dropdown[data-id]';

  function labels() {
    var host = document.getElementById('product-info');
    return {
      more: (host && host.getAttribute('data-more')) || 'Pokaż więcej',
      less: (host && host.getAttribute('data-less')) || 'Pokaż mniej'
    };
  }

  function unclamp(dd, content) {
    content.classList.remove('pg-clamp', 'pg-clamp--opis', 'is-expanded');
    delete content.dataset.pgClamp;
    var b = dd.querySelector(':scope > .pg-view-more');
    if (b) b.remove();
  }

  function apply() {
    var t = labels();
    document.querySelectorAll(SEL_DD).forEach(function (dd, i) {
      var btn = dd.querySelector(':scope > .custom__faq-dropdown-button');
      var content = dd.querySelector(':scope > .Dropdown--Content');
      if (!btn || !content) return;
      dd.classList.remove('pg-acc-closed');
      btn.setAttribute('aria-expanded', 'true');
      if (!content.id) content.id = 'pg-section-content-' + i;
      btn.setAttribute('aria-controls', content.id);
      content.setAttribute('aria-hidden', 'false');
      /* 08.10 (30.9 P5-b, B147 – klawiatura): sekcja jest zawsze otwarta, więc nagłówek nie jest już kontrolką – bez akcji motywu
         (Enter na telefonie dawał przyciemnioną stronę bez okna i blokadę przewijania, na komputerze chował treść) i poza kolejnością Tab */
      btn.removeAttribute('data-action');
      btn.setAttribute('tabindex', '-1');
      if (!mq.matches) { unclamp(dd, content); return; }
      if (content.dataset.pgClamp) return;
      /* pełna wysokość mierzona PRZED przycięciem, przy widocznej treści */
      var full = content.scrollHeight;
      if (!full) return; /* jeszcze niewidoczne - spróbujemy przy następnym wywołaniu */
      content.dataset.pgClamp = '1';
      /* S1 (makieta R49 `.v3-clamp`): opis przycięty do 128 px (ok. pięciu linii), tabela danych jak dotąd do 360 px */
      var limit = i === 0 ? 128 : CLAMP;
      if (full <= limit + SLACK) return;
      content.classList.add('pg-clamp');
      if (i === 0) content.classList.add('pg-clamp--opis');
      var more = document.createElement('button');
      more.type = 'button';
      more.className = 'pg-view-more pg-wiecej-btn'; /* 797 T2 – wspólny przycisk; strzałka zamiast „+” / „−” */
      more.textContent = t.more;
      more.setAttribute('aria-expanded', 'false');
      more.setAttribute('aria-controls', content.id);
      more.addEventListener('click', function () {
        var expanded = content.classList.toggle('is-expanded');
        more.textContent = expanded ? t.less : t.more;
        more.setAttribute('aria-expanded', expanded ? 'true' : 'false');
        if (!expanded) {
          var top = dd.getBoundingClientRect().top;
          if (top < 0) dd.scrollIntoView({ block: 'start', behavior: 'smooth' });
        }
      });
      content.parentNode.insertBefore(more, content.nextSibling);
    });
  }

  function init() {
    apply();
    /* treść bywa dorysowywana po załadowaniu (obrazy, aplikacje) - druga próba po chwili */
    setTimeout(apply, 800);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  if (mq.addEventListener) mq.addEventListener('change', init);
  else if (mq.addListener) mq.addListener(init);
})();

;
/* ===== pdp-sticky-bar.js ===== */
/*
 * v77 UI: lepki pasek zakupu na karcie produktu (snippets/pdp-sticky-bar.liquid).
 * - pokazuje pasek, gdy główny blok "Dodaj do koszyka" jest poza ekranem,
 * - synchronizuje ilość w obie strony z głównym polem .pm__quantity-input,
 * - przycisk w pasku klika główny przycisk, więc koszyk, "Powiadom mnie"
 *   i dobrane akcesoria (pdp-direct-accessories.js) idą tą samą ścieżką.
 * Klasa body .pg-stickybar-visible pozwala odsunąć inne pływające elementy
 * (zakładka opinii Judge.me na telefonie).
 * Klasa body .pg-stickybar-minal (W1, 16.10): główny przycisk minięty (nad górną
 * krawędzią okna) – na komputerze to samo co .pg-stickybar-visible.
 */
(function () {
  if (window.__pgStickyBar) return;
  window.__pgStickyBar = true;

  function init() {
    var bar = document.querySelector('[data-sticky-buy-bar]');
    var mainWrap = document.querySelector('.pm__product-atc-wrapper');
    if (!bar || !mainWrap || !('IntersectionObserver' in window)) return;

    /* Animacje wejścia motywu (Web Animations, fill: forwards) zostawiają transform
       na blokach karty produktu, a transform robi z przodka blok odniesienia dla
       position: fixed. Pasek renderowany w bloku lądował więc na dole kolumny
       zamiast na dole okna (zmierzone: 31 px pod krawędzią). Przenosimy go do body. */
    if (bar.parentElement !== document.body) document.body.appendChild(bar);

    var mainBtn = mainWrap.querySelector('.pm__atc-button--main');
    var qtyInput = document.querySelector('.pm__quantity-input');
    var qtyWrap = bar.querySelector('[data-sticky-qty-wrap]');
    var qtySelect = bar.querySelector('[data-sticky-qty-select]');
    var qtyField = bar.querySelector('[data-sticky-qty]');
    var stickyBtn = bar.querySelector('[data-sticky-atc]');

    var widoczny = null;
    function setVisible(show) {
      if (show === widoczny) return;
      widoczny = show;
      bar.classList.toggle('is-visible', show);
      bar.setAttribute('aria-hidden', show ? 'false' : 'true');
      document.body.classList.toggle('pg-stickybar-visible', show);
    }
    var minal = null;
    function setMinal(m) {
      if (m === minal) return;
      minal = m;
      document.body.classList.toggle('pg-stickybar-minal', m);
    }

    /* S1 (makieta R49 `.v7f-bar`: „widoczny po przewinięciu poniżej »Dodaj do koszyka«”): pasek tylko wtedy, gdy klient
       MINĄŁ główny przycisk (przycisk nad górną krawędzią okna). Do 18.09 pokazywał się też na starcie strony, gdy przycisk
       był jeszcze niżej (na telefonie od razu przy wejściu). Obserwator + przewijanie – skok kotwicą też jest złapany.
       16.10 telefon i tablet (do 1023 px – jedna kolumna karty,
       panel zakupu pod galerią; od 1024 px panel stoi obok zdjęcia) wracają do paska od wejścia: pasek widoczny zawsze, gdy
       głównego przycisku NIE MA na ekranie (jeszcze poniżej albo już powyżej), ukryty, gdy przycisk jest na ekranie. Komputer
       (od 1024 px) bez zmian – reguła S1. Na ekranie = nad strefą paska (dolne 61 px okna; wysokość paska na telefonie,
       przycisk ma 56 px): przycisk wchodzący od dołu jest najpierw pod paskiem, a pasek chowa się dopiero, gdy przycisk
       cały stoi nad nim – zawsze jeden pełny „Dodaj do koszyka” na ekranie. Pod przyklejonym nagłówkiem przycisk liczy się
       jako widoczny (jak w S1 – bez odczytu wysokości nagłówka przy starcie strony). */
    // DECISION: próg 1023 px = próg jednej kolumny karty w motywie (main-product.css: max-width 1023px / min-width 1024px).
    var waski = window.matchMedia ? window.matchMedia('(max-width: 1023px)') : null;
    var ZAPAS_PASKA = 61;
    function pokaz(naEkranie, miniety) {
      setMinal(miniety);
      setVisible(waski && waski.matches ? !naEkranie : miniety);
    }
    function sprawdz() {
      var r = mainWrap.getBoundingClientRect();
      pokaz(r.bottom > 0 && r.top < window.innerHeight - ZAPAS_PASKA, r.bottom < 0);
    }
    /* 25.09 12:0x (krok 30.9 d etap 3; B150, B98): obserwator bierze położenie z WŁASNEGO wpisu (liczonego przy rysowaniu klatki), bez
       `getBoundingClientRect` – ten odczyt przy starcie i w wywołaniu obserwatora wymuszał przeliczenie układu w trakcie budowania strony
       (profil karty na telefonie, procesor ×4: `sprawdz` 561 ms czasu własnego). Wywołanie na starcie zbędne: obserwator zgłasza stan zaraz po
       `observe` (także przy stronie otwartej niżej – przywrócone przewinięcie). Przewijanie zostaje (skok w jednej klatce z nad bloku pod blok
       bez przejścia przez ekran – np. „do góry”); tam odczyt w klatce animacji, przy czystym układzie – tani. */
    /* W1: obszar obserwatora bez dolnych 61 px okna (strefa paska); na komputerze wynik ten sam co w S1 – liczy się tylko
       przycisk nad górną krawędzią, a górnej krawędzi zapas nie zmienia. */
    var observer = new IntersectionObserver(function (wpisy) {
      var w = wpisy[wpisy.length - 1];
      pokaz(w.isIntersecting, !w.isIntersecting && w.boundingClientRect.bottom < 0);
    }, { threshold: 0, rootMargin: '0px 0px -' + ZAPAS_PASKA + 'px 0px' });
    observer.observe(mainWrap);
    var czeka = false;
    window.addEventListener('scroll', function () {
      if (czeka) return;
      czeka = true;
      requestAnimationFrame(function () { czeka = false; sprawdz(); });
    }, { passive: true });
    /* W1: obrót tabletu przez próg 1024 px zmienia regułę – stan od nowa (rzadkie zdarzenie, odczyt położenia tani) */
    if (waski) {
      if (waski.addEventListener) waski.addEventListener('change', sprawdz);
      else if (waski.addListener) waski.addListener(sprawdz);
    }

    /* ---------- ilość ---------- */
    function showSticky(v) {
      v = parseInt(v, 10) || 1;
      if (v <= 9) {
        qtyWrap.classList.remove('pg-stickybar__qty--manual');
        qtySelect.value = String(v);
      } else {
        qtyWrap.classList.add('pg-stickybar__qty--manual');
      }
      if (qtyField.value !== String(v)) qtyField.value = v;
    }

    function pushToMain(v) {
      v = parseInt(v, 10);
      if (!v || v < 1 || !qtyInput) return;
      if (qtyInput.value !== String(v)) {
        qtyInput.value = v;
        qtyInput.dispatchEvent(new Event('input', { bubbles: true }));
        qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    if (qtyWrap && qtySelect && qtyField) {
      qtySelect.addEventListener('change', function () {
        if (qtySelect.value === 'more') {
          qtyWrap.classList.add('pg-stickybar__qty--manual');
          qtyField.value = 10;
          qtyField.focus();
          qtyField.select();
          pushToMain(10);
        } else {
          qtyField.value = qtySelect.value;
          pushToMain(qtySelect.value);
        }
      });
      qtyField.addEventListener('input', function () { pushToMain(qtyField.value); });
      qtyField.addEventListener('change', function () { pushToMain(qtyField.value); });
      qtyField.addEventListener('blur', function () {
        if (!parseInt(qtyField.value, 10)) showSticky(qtyInput ? qtyInput.value : 1);
      });
      if (qtyInput) {
        var syncFromMain = function () { showSticky(qtyInput.value); };
        qtyInput.addEventListener('input', syncFromMain);
        qtyInput.addEventListener('change', syncFromMain);
        /* v83: przyciski +/- motywu zmieniają value programowo, bez zdarzeń input/change,
           więc pasek pokazywał starą ilość (zmierzone: główne pole 2, pasek 1). */
        document.addEventListener('click', function (e) {
          if (e.target && e.target.closest && e.target.closest('.pm__quantity-button')) setTimeout(syncFromMain, 60);
        }, true);
        syncFromMain();
      }
    }

    /* ---------- przycisk ---------- */
    if (stickyBtn && mainBtn) {
      stickyBtn.addEventListener('click', function () {
        if (mainBtn.disabled) return;
        mainBtn.click();
      });
      /* Po dodaniu do koszyka motyw otwiera szufladę; pasek chowamy, żeby nie
         leżał pod nakładką i nie łapał dotknięć po jej zamknięciu z przewiniętą stroną. */
      var mo = new MutationObserver(function () {
        stickyBtn.disabled = !!mainBtn.disabled;
      });
      mo.observe(mainBtn, { attributes: true, attributeFilter: ['disabled'] });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

;
/* ===== powiadom (18.09, S1 – makieta R27) =====
 * Link „Powiadom mnie o dostawie” (snippets/pg-powiadom.liquid) otwiera okno tej samej aplikacji (CartBite), co pełny
 * przycisk – przycisk aplikacji jest wtedy schowany (klasa pg-gw-ukryty), ale jego obsługa działa po kliknięciu z kodu.
 * Gdy aplikacja się nie wczytała (bloker, błąd sieci), link prowadzi zwyczajnie do formularza kontaktu z nazwą i SKU. */
(function () {
  'use strict';
  /* 04.10. Okno aplikacji (ramka `#gw-stock-fulfilled-iframe`, srcdoc – ta sama domena; aplikacja tworzy ją
     przy wczytaniu strony, Vue 2 `growCampaignPopUp` jest już zamontowane i przy każdym otwarciu to ten sam dokument – sonda `dane-2026-10-04/h30-r4/cykl/`)
     dostaje wygląd naszych okien (`.pg-ko` w base-min.css): pasek z tytułem i „×” 44 × 44 px po prawej, czcionka sklepu, pola i pomarańczowy przycisk jak
     w oknie kontaktu, przełącznik E-mail / SMS jak przełącznik języka, komunikat przy złym adresie lub numerze; teksty w języku strony. Klawiatura: fokus
     wchodzi do okna, Tab krąży w oknie, Escape zamyka (w ramce i na stronie), po zamknięciu fokus wraca na odnośnik. Styl trafia do ramki zawczasu
     (bezczynność po wczytaniu) i jeszcze raz przy kliknięciu – bez mignięcia starego wyglądu. Ramki brak albo inna budowa – nic się nie zmienia; aplikacja
     się nie wczytała (brak jej przycisku) – odnośnik „Powiadom mnie o dostawie” prowadzi zwyczajnie do formularza kontaktu (B147). */
  var PL = (document.documentElement.lang || 'pl').toLowerCase().indexOf('en') !== 0;
  var T = PL
    ? { tytul: 'Powiadom mnie o dostawie', zamknij: 'Zamknij', kanal: 'Sposób powiadomienia', email: 'E-mail', adres: 'Adres e-mail', tel: 'Numer telefonu', zlyEmail: 'Wpisz poprawny adres e-mail.', zlyTel: 'Wpisz poprawny numer telefonu.',
      prywEmail: 'Adres e-mail wykorzystamy do powiadomienia o dostępności produktu. Więcej w ', prywTel: 'Numer telefonu wykorzystamy do powiadomienia o dostępności produktu. Więcej w ', prywLink: 'Polityce prywatności' }
    : { tytul: 'Notify me about delivery', zamknij: 'Close', kanal: 'Notification channel', email: '', adres: '', tel: 'Phone number', zlyEmail: 'Enter a valid email address.', zlyTel: 'Enter a valid phone number.',
      prywEmail: 'We will use your email address to notify you when the product is available. More in our ', prywTel: 'We will use your phone number to notify you when the product is available. More in our ', prywLink: 'Privacy Policy' };
  // 06.10 (43.47 – B105, B28, B118): odnośnik do NASZEJ Polityki prywatności (strona `polityka-prywatnosci` – okno dokumentów, pg-dok-okno.liquid)
  var POLITYKA = ((window.Shopify && Shopify.routes && Shopify.routes.root) || '/') + 'pages/polityka-prywatnosci';
  var O = 'html[data-pg-popr] .modal-container';
  var CSS = 'html[data-pg-popr] body.fade-in{background:rgb(20 24 28 / .55)}'
    + O + '{box-sizing:border-box;width:min(440px,calc(100vw - 32px));max-height:calc(100vh - 32px);max-height:calc(100dvh - 32px);overflow:auto;padding:0 20px 20px;border:0;border-radius:12px;background:#fff;box-shadow:0 12px 40px rgb(40 45 52 / .35);font-family:"PG Tekst","Roboto Fallback",Arial,sans-serif;font-size:14px;line-height:20px;color:#1f242a}'
    + O + ' *{color:inherit;font-family:inherit;letter-spacing:0}'
    + O + ' .modal-title{box-sizing:border-box;display:flex;align-items:center;min-height:69px;margin:0 -20px 16px;padding:12px 68px 12px 20px;border-bottom:1px solid #e3e6e8;font-size:18px;line-height:24px;font-weight:700;color:#1f242a;text-align:left}'
    + O + ' .close-icon.action-close{position:absolute;top:12px;right:12px;z-index:1;float:none;display:flex;align-items:center;justify-content:center;box-sizing:border-box;width:44px;height:44px;margin:0;padding:0;border:0;border-radius:8px;background:#f4f6f7;opacity:1;text-shadow:none;font-size:24px;line-height:1;font-weight:400;color:#282d34;cursor:pointer}'
    + O + ' .close-icon.action-close:hover{background:#e3e6e8;color:#282d34}'
    + O + ' .notification-message{margin:0 0 16px;font-size:14px;line-height:20px;color:#3d454d}'
    + O + ' .channel-selector{display:flex;gap:4px;margin:0 0 12px;padding:4px;border-radius:8px;background:#f2f5f6}'
    + O + ' .channel-selector .btn-group{flex:1 1 0;width:auto;min-width:0}'
    + O + ' .channel-selector .btn-group button{box-sizing:border-box;width:100%;min-height:40px;margin:0;padding:0 12px;border:0;border-radius:6px;background:transparent;font-size:14px;line-height:20px;font-weight:600;color:#3d454d;cursor:pointer}'
    + O + ' .channel-selector .btn-group button:hover{background:#e3e6e8}'
    + O + ' .channel-selector .btn-group button.active{background:#282d34;color:#fff}'
    + 'html[data-pg-popr] #email-tab,html[data-pg-popr] #sms-tab{border-radius:6px}'
    + O + ' .email-input{box-sizing:border-box;display:block;width:100%;height:auto;min-height:44px;margin:0;padding:10px 12px;border:0!important;border-radius:6px;background:#fff!important;box-shadow:inset 0 0 0 1px #bfc7cd;font-size:16px;line-height:24px;color:#1f242a}'
    + O + ' .email-input::placeholder,' + O + ' .vue-tel-input input::placeholder{color:#6b757e;opacity:1}'
    + O + ' .email-input:focus{outline:none;box-shadow:inset 0 0 0 2px #282d34}'
    + O + ' .email-input[aria-invalid="true"]{box-shadow:inset 0 0 0 2px #a3261b}'
    + O + ' .vue-tel-input{box-sizing:border-box;height:44px;margin:0;border:0;border-radius:6px;background:#fff;box-shadow:inset 0 0 0 1px #bfc7cd;font-size:16px}'
    + O + ' .vue-tel-input:focus-within{outline:none;background:#fff!important;box-shadow:inset 0 0 0 2px #282d34}'
    + O + ' .vue-tel-input:has(~ small:not(:empty)){box-shadow:inset 0 0 0 2px #a3261b}'
    + O + ' .vue-tel-input input{background:transparent!important;font-size:16px;color:#1f242a}'
    + O + ' .vti__input{padding:0 12px 0 6px;border-radius:0 6px 6px 0}'
    + O + ' .vti__dropdown{padding:0 4px 0 10px;border-radius:6px 0 0 6px}'
    + O + ' .vti__dropdown:hover,' + O + ' .vti__dropdown.open{background:#f4f6f7}'
    + O + ' .vti__dropdown-list{width:min(390px,calc(100vw - 72px));border:0;border-radius:8px;box-shadow:0 8px 24px rgb(40 45 52 / .25)}'
    + O + ' .vti__dropdown-list.below{top:48px}'
    + 'html[data-pg-popr] #gw-email-error,' + O + ' .vue-tel-input ~ small{display:block;margin:6px 0 0;font-size:13px;line-height:18px;color:#a3261b!important}'
    + 'html[data-pg-popr] #gw-email-error:empty,' + O + ' .vue-tel-input ~ small:empty{display:none}'
    + O + ' .notify-button{box-sizing:border-box;display:flex;align-items:center;justify-content:center;width:100%;min-height:44px;margin:16px 0 0;padding:12px 22px;border:0;border-radius:8px;background:#cc4a00;font-size:15px;line-height:20px;font-weight:700;color:#fff;cursor:pointer}'
    + O + ' .notify-button:hover{background:#b34100}'
    + O + ' .gw-success-message.hide-block{display:none}'
    + O + ' .gw-success-message.show-block{display:block;margin:16px 0 0;padding:10px 12px;border:0;border-radius:8px;background:#e3f5e9;font-size:14px;line-height:20px;font-weight:600;color:#0b6b34}'
    + O + ' .gw-success-message .close-text{margin-left:6px;text-decoration:underline;text-underline-offset:2px}'
    + O + ' .privacy-text{margin:12px 0 0;font-size:12px;line-height:16px;color:#5c6771}'
    + O + ' .privacy-text a{color:#3d454d;text-decoration:underline;text-underline-offset:2px}'
    + O + ' .privacy-text a:hover{color:#1f242a}'
    + O + ':focus{box-shadow:0 12px 40px rgb(40 45 52 / .35)!important}'
    + O + ' :is(button,a,[tabindex="0"]):focus-visible{outline:2px solid #282d34;outline-offset:2px}'
    + '@media (max-width:767px){' + O + '{width:calc(100vw - 16px);max-height:calc(100vh - 16px);max-height:calc(100dvh - 16px);padding:0 16px 16px;border-radius:10px}'
    + O + ' .modal-title{margin:0 -16px 16px;padding-left:16px}}';
  var wyzwalacz = null;
  function ramka() { return document.getElementById('gw-stock-fulfilled-iframe'); }
  function dokument(f) { try { return f && f.contentDocument; } catch (e) { return null; } }
  function vue(f) { try { var vm = f && f.contentWindow && f.contentWindow.growCampaignPopUp; return vm && vm._isMounted ? vm : null; } catch (e) { return null; } }
  function otwarte(f) { return !!f && f.style.display !== 'none' && getComputedStyle(f).display !== 'none'; }
  function zamknij() {
    var f = ramka(); var d = dokument(f);
    if (!d || !otwarte(f)) return;
    var x = d.querySelector('.close-icon.action-close');
    if (x) x.click();
  }
  // @font-face „PG Tekst” i „Roboto Fallback” z <style> strony (snippets/variables.liquid) – ramka nie dziedziczy czcionek strony
  function kroje() {
    var o = '';
    var st = document.querySelectorAll('style');
    for (var i = 0; i < st.length; i++) {
      if (st[i].textContent.indexOf('PG Tekst') < 0) continue;
      var r = null;
      try { r = st[i].sheet && st[i].sheet.cssRules; } catch (e) { r = null; }
      if (!r) continue;
      for (var j = 0; j < r.length; j++) {
        if (r[j].type !== 5) continue;
        var fam = r[j].style.getPropertyValue('font-family');
        if (fam.indexOf('PG Tekst') >= 0 || fam.indexOf('Roboto Fallback') >= 0) o += r[j].cssText;
      }
    }
    return o;
  }
  // tekst węzła, który Vue wyrenderował z szablonu bez wiązania – zmiana wartości węzła (nie podmiana), więc Vue jej nie nadpisze
  function tekst(el, t) {
    if (!el || !t) return;
    var n = el.firstChild;
    if (n && n.nodeType === 3) { if (n.nodeValue !== t) n.nodeValue = t; } else if (el.textContent !== t) el.textContent = t;
  }
  // komunikat przy złym adresie / numerze (szablon aplikacji ma puste `<small role="alert">`); przy zmianie E-mail ↔ SMS Vue używa tych samych
  // elementów `small` w nowym miejscu – każdy dostaje tekst od nowa, a niepasujący jest czyszczony (04.10 19:5x: po SMS zostawał komunikat o adresie)
  function stanPol(d, vm) {
    var tel = d.querySelector('.vue-tel-input ~ small');
    [].forEach.call(d.querySelectorAll('.modal-container small[role="alert"]'), function (s) {
      var t = '';
      if (s.id === 'gw-email-error') t = vm.isEmailValid === false ? T.zlyEmail : '';
      else if (s === tel) t = (vm.isPhoneNumberValid === false || vm.isCountryCodeValid === false) ? T.zlyTel : '';
      if (s.textContent !== t) s.textContent = t;
    });
    var ti = d.querySelector('.vue-tel-input input');
    if (ti) { if (ti.placeholder !== T.tel) ti.placeholder = T.tel; if (ti.getAttribute('aria-label') !== T.tel) ti.setAttribute('aria-label', T.tel); }
  }
  // 06.10 (43.47 – B105, B28): zdanie aplikacji „Szanujemy Twoją prywatność i nie udostępniamy Twojego adresu e-mail nikomu” przeczy Polityce prywatności 3.3
  // (pkt 4 – CartBite, dostawca aplikacji, jest odbiorcą danych; pkt 3 – cel „Powiadom mnie”), a w zakładce SMS mówi o adresie e-mail. Nasze zdanie: do czego
  // posłuży adres albo numer (cel z Polityki, bez nowych obietnic) + odnośnik do Polityki. Tekst siedzi w `vm.privacyText` (wiązanie Vue, jeden węzeł tekstu) –
  // ustawiamy go i ten sam węzeł, a odnośnik i kropka idą ZA nim (Vue zmienia tylko swój węzeł); aplikacja wpisuje swój tekst przy każdym otwarciu – stąd
  // wywołanie przy każdym pokazaniu okna i przy zmianie E-mail ↔ SMS (sonda 06.10 22:3x: `selectedChannel` = „email” / „sms”).
  function prywatnosc(d, vm) {
    var p = d.querySelector('.modal-container .privacy-text');
    if (!p) return;
    var t = vm.selectedChannel === 'sms' ? T.prywTel : T.prywEmail;
    if (vm.privacyText !== t) vm.privacyText = t;
    var n = p.firstChild;
    var a = p.querySelector('a[data-pg-pp]');
    if (n && n.nodeType === 3 && n.nodeValue === t && a && a.previousSibling === n && a.nextSibling && a.nextSibling.nodeValue === '.' && !a.nextSibling.nextSibling) return;
    if (!n || n.nodeType !== 3) { n = d.createTextNode(''); p.insertBefore(n, p.firstChild); }
    n.nodeValue = t;
    while (n.nextSibling) p.removeChild(n.nextSibling);
    a = d.createElement('a');
    a.href = POLITYKA;
    a.target = '_blank';
    a.rel = 'noopener';
    a.setAttribute('data-pg-pp', '');
    a.textContent = T.prywLink;
    p.appendChild(a);
    p.appendChild(d.createTextNode('.'));
  }
  // klik w odnośnik do Polityki: NASZE okno dokumentu nad oknem „Powiadom mnie” (B118 – obszar zakupu; natywny <dialog> w warstwie wierzchniej, więc okno
  // aplikacji zostaje z wpisanym adresem pod spodem). Okno dokumentu otwiera jego własna obsługa w pg-global.js (część „dok-okno”) – dostaje kliknięcie
  // w tymczasowy odnośnik w obszarze zakupu; gdy go nie przechwyci (brak okna, inna strona) – nowa karta zamiast wyjścia z karty produktu (B112).
  function politykaWOknie(ev) {
    var a = ev.target && ev.target.closest ? ev.target.closest('a[data-pg-pp]') : null;
    if (!a || ev.button !== 0 || ev.metaKey || ev.ctrlKey || ev.shiftKey || ev.altKey) return;
    ev.preventDefault();
    var href = a.getAttribute('href');
    var miejsce = (wyzwalacz && wyzwalacz.isConnected && wyzwalacz.parentNode) || document.querySelector('.pm__content');
    var przechwycone = false;
    if (miejsce && document.querySelector('dialog[data-pg-dok]')) {
      var tmp = document.createElement('a');
      tmp.href = href;
      tmp.hidden = true;
      miejsce.appendChild(tmp);
      var stop = function (e) { przechwycone = e.defaultPrevented; if (!e.defaultPrevented) e.preventDefault(); };
      window.addEventListener('click', stop);
      tmp.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, button: 0 }));
      window.removeEventListener('click', stop);
      tmp.remove();
    }
    if (!przechwycone) { window.open(href, '_blank', 'noopener'); return; }
    // po zamknięciu Polityki fokus wraca na odnośnik w oknie aplikacji (przeglądarka oddawała go na <body> – test 06.10 22:5x; WCAG 2.4.3)
    var okno = document.querySelector('dialog[data-pg-dok]');
    if (okno) okno.addEventListener('close', function () {
      var f = ramka();
      if (!otwarte(f) || !a.isConnected) return;
      try { f.focus({ preventScroll: true }); a.focus({ preventScroll: true }); } catch (e) { /* bez fokusu */ }
    }, { once: true });
  }
  function klawisze(ev) {
    if (ev.key === 'Escape') { zamknij(); return; }
    if (ev.key !== 'Tab') return;
    var d = dokument(ramka());
    if (!d) return;
    var w = d.defaultView;
    var l = [].filter.call(d.querySelectorAll('.modal-container button, .modal-container input, .modal-container a[href], .modal-container [tabindex="0"]'), function (e) {
      return !e.disabled && e.getClientRects().length > 0 && w.getComputedStyle(e).visibility !== 'hidden';
    });
    if (!l.length) return;
    var i = l.indexOf(d.activeElement);
    if (ev.shiftKey && i <= 0) { ev.preventDefault(); l[l.length - 1].focus(); } else if (!ev.shiftKey && (i < 0 || i === l.length - 1)) { ev.preventDefault(); l[0].focus(); }
  }
  // teksty i opisy w języku strony – przy przygotowaniu i przy KAŻDYM pokazaniu okna: aplikacja przed pokazaniem wpisuje swoje (`performTranslation` →
  // `translateStockWidget`: tytuł, opis, przycisk, zgoda, podpowiedź pola – `innerText` / `placeholder`; main.js aplikacji, odczyt 04.10 19:5x)
  function teksty(f, d, vm) {
    if (f.getAttribute('title') !== T.tytul) f.setAttribute('title', T.tytul);
    var c = d.querySelector('.modal-container');
    if (!c) return;
    var x = c.querySelector('.close-icon.action-close');
    if (x) { if (x.getAttribute('aria-label') !== T.zamknij) x.setAttribute('aria-label', T.zamknij); tekst(x, '×'); }
    var h = c.querySelector('.modal-title');
    if (h) {
      if (h.id !== 'pg-cb-tytul') h.id = 'pg-cb-tytul';
      tekst(h, T.tytul);
      var el = d.getElementById('el');
      if (el && el.getAttribute('aria-labelledby') !== 'pg-cb-tytul') el.setAttribute('aria-labelledby', 'pg-cb-tytul');
    }
    var k = c.querySelector('.channel-selector');
    if (k && k.getAttribute('aria-label') !== T.kanal) k.setAttribute('aria-label', T.kanal);
    tekst(d.getElementById('email-tab'), T.email);
    if (T.adres) {
      if (vm.emailPlaceholder !== T.adres) vm.emailPlaceholder = T.adres;
      var em = c.querySelector('.email-input');
      if (em && em.placeholder !== T.adres) em.placeholder = T.adres;
    }
    if (vm.phoneNumberPlaceholder !== T.tel) vm.phoneNumberPlaceholder = T.tel;
    stanPol(d, vm);
    prywatnosc(d, vm);
  }
  // aplikacja pokazuje okno dopiero po swoim `ensureCookies` (bywa zapytanie do jej serwera `subscribers/uniqueId`; 04.10 19:4x – brak odpowiedzi,
  // 19:5x – 8,5 s na odpowiedź): gdy okna nie widać po 0,3 s, odnośnik jest „zajęty” (aria-busy, kursor czekania) do pokazania okna, najdłużej 15 s
  var czekaEl = null, czekaT = 0, czekaT0 = 0;
  function czekanie(a) {
    koniecCzekania();
    czekaT0 = setTimeout(function () {
      if (otwarte(ramka())) return;
      czekaEl = a;
      a.setAttribute('aria-busy', 'true'); a.style.cursor = 'progress'; a.style.opacity = '.6';
      // 06.10 (43.46 – B147): 15 s bez okna = serwer aplikacji milczy (04.10 20:14 – raz na ok. 30 otwarć) → następne kliknięcie otwiera NASZE okno kontaktu
      // z nazwą i SKU (`window.pgCbMilczy` czyta też obsługa okna kontaktu w pg-global.js); flaga gaśnie, gdy okno aplikacji się pokaże
      czekaT = setTimeout(function () { var cisza = !otwarte(ramka()); koniecCzekania(); if (cisza) window.pgCbMilczy = true; }, 15000);
    }, 300);
  }
  // pełny przycisk aplikacji (produkt bez stanu i bez sprzedaży – pg-powiadom.liquid, v5 R10) przy milczącym serwerze: okno kontaktu przez tymczasowy odnośnik
  // „Kontakt” z nazwą i SKU w obszarze zakupu (otwiera je obsługa w pg-global.js); bez nazwy albo SKU na stronie – zostaje aplikacja
  function kontaktZamiast(a, e) {
    var h = document.querySelector('h1.pm__title');
    var s = document.querySelector('input[name="id"][data-sku]');
    var sku = s ? s.getAttribute('data-sku') : '';
    if (!h || !sku || !a.parentNode) return false;
    e.preventDefault();
    e.stopImmediatePropagation();
    var tmp = document.createElement('a');
    tmp.href = ((window.Shopify && Shopify.routes && Shopify.routes.root) || '/') + 'pages/kontakt?produkt=' + encodeURIComponent(h.textContent.trim()) + '&sku=' + encodeURIComponent(sku) + '#contactForm';
    tmp.hidden = true;
    a.parentNode.appendChild(tmp);
    tmp.click();
    tmp.remove();
    return true;
  }
  function koniecCzekania() {
    clearTimeout(czekaT0); clearTimeout(czekaT);
    if (!czekaEl) return;
    czekaEl.removeAttribute('aria-busy'); czekaEl.style.cursor = ''; czekaEl.style.opacity = '';
    czekaEl = null;
  }
  function pokazane(f, d, vm) {
    // 43.46: okno aplikacji przyszło PO 15 s ciszy (klient dostał już nasze okno kontaktu albo przestał czekać) – zamykamy je, nic bez kliknięcia klienta
    // (B126); następne kliknięcie znów przez aplikację
    if (window.pgCbMilczy) { window.pgCbMilczy = false; koniecCzekania(); zamknij(); return; }
    teksty(f, d, vm);
    koniecCzekania();
    var c = d.querySelector('.modal-container');
    if (c && wyzwalacz && d.activeElement !== c && !c.contains(d.activeElement)) { try { c.focus({ preventScroll: true }); } catch (e) { /* bez fokusu */ } }
  }
  function przygotuj() {
    var f = ramka(); var d = dokument(f); var vm = vue(f);
    if (!d || !d.head || !vm || !d.querySelector('.modal-container')) return false;
    if (d.documentElement.hasAttribute('data-pg-popr')) return true;
    var st = d.createElement('style');
    st.textContent = kroje() + CSS;
    d.head.appendChild(st);
    d.documentElement.setAttribute('data-pg-popr', '');
    vm.$watch(function () { return [this.isEmailValid, this.isPhoneNumberValid, this.isCountryCodeValid, this.selectedChannel].join(); }, function () {
      vm.$nextTick(function () { stanPol(d, vm); prywatnosc(d, vm); });
    });
    d.addEventListener('keydown', klawisze);
    d.addEventListener('click', politykaWOknie);
    // aplikacja pokazuje i chowa ramkę stylem (`display`): pokazanie → nasze teksty przed narysowaniem (obserwator działa przed malowaniem) i fokus do okna;
    // schowanie → fokus wraca na odnośnik albo przycisk, który okno otworzył
    var bylo = otwarte(f);
    new MutationObserver(function () {
      var jest = otwarte(f);
      if (jest) pokazane(f, d, vm);
      else if (bylo) {
        if (wyzwalacz && document.activeElement === f) { try { wyzwalacz.focus({ preventScroll: true }); } catch (e) { /* bez fokusu */ } }
        wyzwalacz = null;
      }
      bylo = jest;
    }).observe(f, { attributes: true, attributeFilter: ['style'] });
    teksty(f, d, vm);
    if (bylo) pokazane(f, d, vm);
    return true;
  }
  // po kliknięciu: przygotowanie od razu (zanim aplikacja pokaże ramkę); Vue w ramce bywa jeszcze niegotowe – próby co 0,1 s do 20 s
  function dolacz() {
    var n = 0;
    (function proba() { if (przygotuj() || ++n > 200) return; setTimeout(proba, 100); })();
  }
  // Escape W otwartym oknie (np. Polityka prywatności otwarta z okna aplikacji – 43.47) zamyka tylko to okno; okno aplikacji zostaje pod spodem. Warunek po
  // miejscu klawisza, nie „jakiekolwiek dialog[open]” – okno zgód CookieFirst to też otwarty `dialog` (test 06.10 22:4x: drugi Escape nie zamykał okna aplikacji)
  document.addEventListener('keydown', function (ev) { if (ev.key === 'Escape' && !(ev.target && ev.target.closest && ev.target.closest('dialog[open]'))) zamknij(); });
  document.addEventListener('click', function (e) {
    var a = e.target.closest ? e.target.closest('[data-pg-powiadom], .gw-button-widget') : null;
    if (!a) return;
    if (a.hasAttribute('data-pg-powiadom')) {
      var przycisk = document.querySelector('.pm__product-atc-wrapper .gw-button-widget');
      // aplikacja się nie wczytała albo jej serwer milczał 15 s (43.46) – zwykły odnośnik do formularza kontaktu z nazwą i SKU (okno kontaktu – pg-global.js)
      if (!przycisk || window.pgCbMilczy) return;
      e.preventDefault();
      wyzwalacz = a;
      dolacz();
      przycisk.click();
      if (!otwarte(ramka())) czekanie(a);
      return;
    }
    if (!e.isTrusted) return; // kliknięcie z kodu (wyżej) – już obsłużone
    if (window.pgCbMilczy && kontaktZamiast(a, e)) return;
    wyzwalacz = a;
    dolacz();
    if (!otwarte(ramka())) czekanie(a);
  }, true);
  // styl zawczasu – w bezczynności po wczytaniu strony (ramka i Vue powstają przy wczytaniu; próby co 0,5 s do 10 s)
  function zawczasu() {
    var n = 0;
    (function proba() { if (przygotuj() || ++n > 20) return; setTimeout(proba, 500); })();
  }
  function pozniej() { if ('requestIdleCallback' in window) requestIdleCallback(zawczasu, { timeout: 4000 }); else setTimeout(zawczasu, 1500); }
  if (document.readyState === 'complete') pozniej(); else window.addEventListener('load', pozniej);
})();

;
/* ===== sekcje (18.09, krok B6 planu 211) ===== */
/*
 * PASEK SEKCJI KARTY PRODUKTU (makieta v8, ramki R14–R19; snippets/pg-sekcje.liquid).
 * Pastylki pod kartą przełączają w tym samym miejscu pudełka [data-pg-pane]:
 *   opis (domyślne) | akcesoria | czesci | opinie, a „Pytania i odpowiedzi” przewijają do sekcji FAQ.
 * Widżet opinii Judge.me stoi w szablonie na dole strony – tutaj przenosimy całą jego sekcję
 * do pudełka „opinie” (raz, zaraz po wczytaniu), a przypis o pochodzeniu opinii wstawiamy
 * pod nagłówek widżetu, dokładnie jak w makiecie (ramki R17/R18, uwaga 148-8).
 * Listy akcesoriów i części (snippets/pg-lista.liquid) przychodzą z serwera w całości:
 * stan zwinięty robi CSS, a tu obsługujemy „Pokaż wszystkie (N)”, „Pokaż kolejne (N)” i „Pokaż mniej”
 * (rzędy po 4, najwyżej 12 naraz – makieta R16).
 * Bez skryptu pasek jest ukryty (CSS html.no-js), a wszystkie pudełka stoją jedno pod drugim.
 */
(function () {
  'use strict';
  var KROK = 12; /* ile kart dokłada jedno kliknięcie – makieta R16 */
  var pasek = document.querySelector('[data-pg-sek]');
  if (!pasek) return;
  var dom = pasek.parentElement;
  var pudelka = dom.querySelectorAll('[data-pg-pane]');
  var faq = document.querySelector('[id*="section_faq"], .shopify-section:has(faq-search)');
  /* Od 768 px (tablet i komputer) pasek ma pięć pastylek i przełącza wszystkie pudełka.
     Na telefonie (makieta R49) opis stoi zawsze, a pastylki są tylko przełącznikiem list. */
  var mqPasek = window.matchMedia('(min-width: 768px)');

  /* 21.09 (T2 – MAKIETA-F, doprecyzowanie F4). Na tablecie i komputerze pasek NIE przełącza już
     pudełek, tylko ROZWIJA je nad opisem:
       · „Akcesoria”, „Części zamienne”, „Opinie” – rozwijają się i zwijają (można mieć rozwinięte więcej niż jedno),
         a „Opis i dane techniczne” zostaje zawsze pod nimi i tylko zjeżdża niżej (płynne przejście w CSS),
       · „Opis i dane techniczne” – zwija wszystkie rozwinięte pudełka (powrót do stanu podstawowego),
       · „Pytania i odpowiedzi” – przewija do sekcji FAQ na dole strony i JEDNOCZEŚNIE przywraca stan podstawowy
         wyżej (żeby po powrocie w górę był opis i dane techniczne, a nie opinie – tak prosił właściciel).
     Na telefonie zostaje makieta R49: opis stoi zawsze, a pasek jest przełącznikiem list (jedna naraz). */
  var ROZWIJANE = ['akcesoria', 'czesci', 'opinie'];
  function panel(nazwa) { return dom.querySelector('[data-pg-pane="' + nazwa + '"]'); }
  function ustawPastylki() {
    var cosOtwarte = false;
    ROZWIJANE.forEach(function (n) { var p = panel(n); if (p && p.classList.contains('is-on')) cosOtwarte = true; });
    pasek.querySelectorAll('.pg-sek__pill').forEach(function (b) {
      var cel = b.getAttribute('data-pg-sek-cel');
      if (cel === 'pytania') return;
      var p = panel(cel);
      var on = cel === 'opis' ? !cosOtwarte : !!(p && p.classList.contains('is-on'));
      b.classList.toggle('is-on', on);
      b.setAttribute('aria-expanded', on ? 'true' : 'false');
    });
  }
  function zwinWszystko() {
    ROZWIJANE.forEach(function (n) { var p = panel(n); if (p) p.classList.remove('is-on'); });
    var opis = panel('opis');
    if (opis) opis.classList.add('is-on');
    ustawPastylki();
  }
  /* pokaz(nazwa): na komputerze „rozwiń to pudełko” (opis = zwiń wszystko), na telefonie – przełącznik jak dotąd.
     Zwraca true, gdy pudełko o tej nazwie istnieje (tak samo jak przed zmianą – korzystają z tego odnośniki niżej). */
  function pokaz(nazwa, przelacz) {
    if (!mqPasek.matches) {
      var jest = false;
      pudelka.forEach(function (p) {
        var on = p.getAttribute('data-pg-pane') === nazwa;
        p.classList.toggle('is-on', on);
        if (on) jest = true;
      });
      pasek.querySelectorAll('.pg-sek__pill').forEach(function (b) {
        var on = b.getAttribute('data-pg-sek-cel') === nazwa;
        b.classList.toggle('is-on', on);
        b.setAttribute('aria-expanded', on ? 'true' : 'false');
      });
      return jest;
    }
    if (nazwa === 'opis') { zwinWszystko(); return true; }
    var p = panel(nazwa);
    if (!p) return false;
    var opis = panel('opis');
    if (opis) opis.classList.add('is-on');
    /* 21.09 wieczór (T3 – zgłoszenie; „Opinie” ma nie pokazywać już Akcesoriów ani Części): rozwinięte
       jest najwyżej JEDNO pudełko naraz – otwarcie kolejnego zwija pozostałe (zmienia doprecyzowanie F4 z 259 „można mieć
       rozwinięte więcej niż jedno”); „Opis i dane techniczne” dalej stoi pod spodem. */
    var bylo = p.classList.contains('is-on');
    ROZWIJANE.forEach(function (n) { var x = panel(n); if (x && x !== p) x.classList.remove('is-on'); });
    if (przelacz && bylo) p.classList.remove('is-on');
    else p.classList.add('is-on');
    ustawPastylki();
    return true;
  }
  window.pgSekcjePokaz = pokaz;

  pasek.addEventListener('click', function (e) {
    var pill = e.target.closest ? e.target.closest('.pg-sek__pill') : null;
    if (!pill) return;
    var cel = pill.getAttribute('data-pg-sek-cel');
    if (cel === 'pytania') {
      /* stan podstawowy wyżej + przewinięcie do pytań na dole strony.
         22.09 (T2: „odnośnik w zakładkach obok opinii przenosi na sam dół strony zamiast na początek FAQ”). Pomiar: `scrollIntoView`
         stawiał początek sekcji przy górnej krawędzi OKNA (0 px), czyli POD przyklejonym nagłówkiem (122 px) – nagłówek „Pytania i odpowiedzi”
         był zasłonięty i widać było tylko koniec strony. Teraz cel = początek sekcji 16 px PONIŻEJ nagłówka strony; po dojechaniu jedno
         wyrównanie, bo treści po drodze (karuzele, opinie) dociągają się przy przewijaniu i przesuwają cel. */
      if (mqPasek.matches) zwinWszystko();
      if (faq) {
        var naglowekStrony = document.querySelector('header-component');
        var idzDoPytan = function (gladko) {
          var zapas = (naglowekStrony ? Math.max(0, Math.min(200, naglowekStrony.getBoundingClientRect().bottom)) : 0) + 16;
          var odchylka = faq.getBoundingClientRect().top - zapas;
          if (!gladko && Math.abs(odchylka) < 8) return;
          window.scrollTo({ top: Math.max(0, window.pageYOffset + odchylka), behavior: gladko ? 'smooth' : 'auto' });
        };
        /* wyrównanie tylko wtedy, gdy klient w tym czasie sam nie przewija (kółko, dotyk, klawisz) – inaczej strona by mu „uciekała” */
        var ruszyl = false;
        var stop = function () { ruszyl = true; };
        ['wheel', 'touchstart', 'keydown'].forEach(function (z) { window.addEventListener(z, stop, { passive: true, once: true }); });
        idzDoPytan(true);
        setTimeout(function () { if (!ruszyl) idzDoPytan(false); }, 1200);
        setTimeout(function () { if (!ruszyl) idzDoPytan(false); ['wheel', 'touchstart', 'keydown'].forEach(function (z) { window.removeEventListener(z, stop); }); }, 2100);
      }
      return;
    }
    pokaz(cel, true);
  });

  /* Odnośniki z panelu zakupu do pudełka sekcji (S1, makieta R51: „Stan egzemplarza – w opisie produktu · Zobacz”
     przy egzemplarzu OUTLET): data-pg-sek-do="opis" włącza pudełko i przewija do niego. Bez skryptu działa kotwica. */
  document.addEventListener('click', function (e) {
    var a = e.target.closest ? e.target.closest('[data-pg-sek-do]') : null;
    if (!a) return;
    var cel = a.getAttribute('data-pg-sek-do');
    if (!pokaz(cel)) return;
    e.preventDefault();
    var pudelko = dom.querySelector('[data-pg-pane="' + cel + '"]');
    (pudelko || pasek).scrollIntoView({ behavior: 'smooth', block: 'start' });
  });

  /* Skrót ze znacznika ocen pod tytułem („★ 4,7 (6 opinii)”) i z każdego odnośnika do widżetu.
     27.10.2026 od 768 px cel przewinięcia to pudełko
     „Opinie” 16 px pod dolną krawędzią przyklejonego nagłówka strony, jak na telefonie (doOpinii w sections/pg-opinie-widzet.liquid) i przy
     „Pytania i odpowiedzi” wyżej. Dotąd pasek sekcji stawał przy górnej krawędzi okna, pod nagłówkiem (122 px), i nagłówek opinii był zasłonięty
     o 44 px. DECISION: dół nagłówka liczony po przewinięciu (grupa nagłówka jest sticky z top 0,
     pasek ogłoszeń nad nią odjeżdża: 154 px przy górze strony, 122 px po przewinięciu), więc jedno płynne przewinięcie bez poprawki o 32 px na końcu;
     po 1,2 s jedno wyrównanie bez animacji tylko, gdy klient sam nie przewija i odchyłka >= 8 px (treść dociągana po drodze). Telefon bez zmian. */
  function dolNaglowkaPoPrzewinieciu() {
    var hd = document.querySelector('header-component');
    if (!hd) return 0;
    var r = hd.getBoundingClientRect();
    var s = hd.parentElement;
    while (s && s !== document.body && getComputedStyle(s).position !== 'sticky') s = s.parentElement;
    if (!s || s === document.body) return Math.max(0, Math.min(200, r.bottom));
    var g = parseFloat(getComputedStyle(s).top) || 0;
    return Math.max(0, Math.min(200, g + r.bottom - s.getBoundingClientRect().top));
  }
  function doOpiniiKomputer(gladko) {
    var cel = panel('opinie') || pasek;
    var odch = cel.getBoundingClientRect().top - (dolNaglowkaPoPrzewinieciu() + 16);
    if (!gladko && Math.abs(odch) < 8) return;
    window.scrollTo({ top: Math.max(0, Math.round(window.pageYOffset + odch)), behavior: gladko ? 'smooth' : 'auto' });
  }
  document.addEventListener('click', function (e) {
    var a = e.target.closest ? e.target.closest('a[href*="judgeme"], .jdgm-preview-badge') : null;
    if (!a) return;
    if (!pokaz('opinie')) return;
    e.preventDefault();
    if (!mqPasek.matches) { pasek.scrollIntoView({ behavior: 'smooth', block: 'start' }); return; }
    doOpiniiKomputer(true);
    var ruszyl = false;
    var stop = function () { ruszyl = true; };
    ['wheel', 'touchstart', 'keydown'].forEach(function (z) { window.addEventListener(z, stop, { passive: true, once: true }); });
    setTimeout(function () {
      if (!ruszyl) doOpiniiKomputer(false);
      ['wheel', 'touchstart', 'keydown'].forEach(function (z) { window.removeEventListener(z, stop); });
    }, 1200);
  });

  /* --- widżet opinii do pudełka „opinie” + przypis pod nagłówkiem widżetu ---
     Tylko od 768 px (tablet i komputer): na telefonie makieta (R49) zostawia opinie jako zwykłą
     sekcję na dole karty, a z paska zostaje sam przełącznik „Akcesoria | Części zamienne”. */
  var paneOpinie = dom.querySelector('[data-pg-pane="opinie"]');
  /* 21.09 (F4): wewnątrz pudełka opinii jest opakowanie `.pg-lista__wrap` – to ono ma `overflow: hidden`
     przy animacji rozwijania, więc widżet trafia do niego, nie wprost do pudełka. */
  var celOpinii = (paneOpinie && paneOpinie.querySelector('.pg-lista__wrap')) || paneOpinie;
  var domOpinii = null, domOpiniiNastepny = null;
  function przeniesOpinie() {
    if (!paneOpinie) return true;
    /* 22.10 (audyt B, wiersz 3): widżet stoi w <template> do zamiaru (sections/pg-opinie-widzet.liquid) – przenosimy jego miejsce `[data-pg-opinie-leniwe]` */
    var widget = document.querySelector('#judgeme_product_reviews, .jdgm-widget.jdgm-review-widget, [data-pg-opinie-leniwe]');
    if (!widget) return false;
    var sekcja = widget.closest('.shopify-section') || widget;
    if (!domOpinii) { domOpinii = sekcja.parentElement; domOpiniiNastepny = sekcja.nextElementSibling; }
    if (mqPasek.matches) {
      if (sekcja.parentElement !== celOpinii) celOpinii.appendChild(sekcja);
    } else if (sekcja.parentElement === celOpinii && domOpinii) {
      if (domOpiniiNastepny && domOpiniiNastepny.parentElement === domOpinii) domOpinii.insertBefore(sekcja, domOpiniiNastepny);
      else domOpinii.appendChild(sekcja);
    }
    return true;
  }
  /* Judge.me dorysowuje widżet po chwili – przypis wchodzi pod nagłówek („Recenzje klientów”),
     nad zakładkami „Recenzje produktu / Recenzje sklepu”, dokładnie jak w makiecie (uwaga 148-8).
     Nazwy klas z odczytu widżetu 18.09: nowy układ `jm-*`, starszy `jdgm-rev-widg__*`. */
  function przypisPodNaglowek() {
    var nota = document.querySelector('.pg-opinie-nota');
    var tytul = document.querySelector('.jm-review-widget-minimal-header__title, .jdgm-rev-widg__title');
    if (!nota || !tytul) return false;
    var blok = tytul.closest('.jm-cluster') || tytul.closest('.jdgm-rev-widg__header') || tytul.parentElement;
    if (!blok) return false;
    if (nota.previousElementSibling === blok) return true;
    var stara = nota.closest('.shopify-section');
    blok.insertAdjacentElement('afterend', nota);
    if (stara && !stara.querySelector('.pg-opinie-nota') && !stara.textContent.trim()) stara.hidden = true;
    return true;
  }
  /* --- F4 (21.09, T2 – MAKIETA-F): produkt BEZ własnych opinii ---
     Judge.me pokazuje wtedy listę „Recenzje dla innych produktów (N)” z własną paginacją (na telefonie
     ok. 5 ekranów między danymi technicznymi a pytaniami). Sam widżet mówi o tym atrybutem
     `data-empty-state="other_products_reviews"`. Zostawiamy nagłówek, zakładki, „Napisz recenzję”
     i zdanie „Recenzje dla innych produktów (N)”, a samą listę i paginację chowa CSS – tu dokładamy
     przycisk, który je pokazuje na żądanie. Nie ruszamy kodu aplikacji: tylko klasa na widżecie. */
  function zwinCudzeOpinie() {
    var w = document.querySelector('.jdgm-widget[data-empty-state="other_products_reviews"]');
    if (!w) return true; /* produkt ma własne opinie albo widżetu nie ma – nic do roboty */
    var naglowek = w.querySelector('.jm-other-products-reviews-text');
    if (!naglowek) return false; /* widżet jeszcze się rysuje */
    if (w.querySelector('.pg-opinie-wiecej')) return true;
    var etykieta = (paneOpinie && paneOpinie.getAttribute('data-opinie-pokaz')) || '';
    if (!etykieta) return true;
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'pg-opinie-wiecej pg-wiecej-btn'; /* 797 T2 */
    b.textContent = etykieta;
    b.setAttribute('aria-expanded', 'false');
    b.addEventListener('click', function () {
      w.classList.add('pg-opinie-rozwiniete');
      b.setAttribute('aria-expanded', 'true');
      b.hidden = true;
    });
    naglowek.insertAdjacentElement('afterend', b);
    return true;
  }
  /* 25.09 (PSI po H12 – SEO „Linków nie można zindeksować”): w oknie „Napisz recenzję” Judge.me przycisk „Wstecz”
     to <a> bez href z własnym kliknięciem – Lighthouse liczy go jako link niemożliwy do zindeksowania (SEO 92).
     Dostaje rolę przycisku (Lighthouse pomija elementy z `role`) i obsługę klawiatury; kliknięcie aplikacji bez zmian.
     Judge.me tworzy okno od nowa przy każdym „Napisz recenzję” (pomiar 25.09), więc obserwator patrzy tylko
     na bezpośrednie dzieci rodzica okna (bez całego DOM) i poprawia każde nowe okno. */
  function poprawOknoOpinii(okno) {
    okno.querySelectorAll('a:not([href]):not([role])').forEach(function (a) {
      a.setAttribute('role', 'button');
      if (!a.hasAttribute('tabindex')) a.setAttribute('tabindex', '0');
      a.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); a.click(); }
      });
    });
  }
  var oknoOpiniiObserwowane = false;
  function przyciskiOknaOpinii() {
    var okno = document.querySelector('.jdgm-write-review-modal');
    if (!okno) return !document.querySelector('.jdgm-widget'); /* okno dorysowuje Judge.me razem z widżetem */
    poprawOknoOpinii(okno);
    if (!oknoOpiniiObserwowane && okno.parentElement && window.MutationObserver) {
      oknoOpiniiObserwowane = true;
      new MutationObserver(function () {
        var nowe = document.querySelector('.jdgm-write-review-modal');
        if (nowe) poprawOknoOpinii(nowe);
      }).observe(okno.parentElement, { childList: true });
    }
    return true;
  }
  var zegarPilnuj = 0;
  function pilnuj() {
    var koniec = Date.now() + 15000;
    clearInterval(zegarPilnuj);
    zegarPilnuj = setInterval(function () {
      var przeniesione = przeniesOpinie();
      var podpiete = przypisPodNaglowek();
      var zwiniete = zwinCudzeOpinie();
      var okno = przyciskiOknaOpinii();
      if ((przeniesione && podpiete && zwiniete && okno) || Date.now() > koniec) clearInterval(zegarPilnuj);
    }, 300);
  }
  przeniesOpinie();
  pilnuj();
  /* 22.10 (audyt B, wiersz 3): widżet wstawiany przy zamiarze (sections/pg-opinie-widzet.liquid) – pilnowanie od nowa, 15 s od wstawienia */
  document.addEventListener('pg:opinie-wstawione', function () { przeniesOpinie(); pilnuj(); });

  /* --- listy: „Pokaż wszystkie (N)” / „Pokaż kolejne (N)” / „Pokaż mniej” --- */
  function tekst(el, klucz, ile) {
    var wzor = el.getAttribute(klucz) || '';
    return wzor.replace('[ile]', ile);
  }
  function odswiez(lista) {
    var karty = lista.querySelectorAll('.pg-lista__item');
    var limit = parseInt(lista.getAttribute('data-limit') || '0', 10);
    var wiecej = lista.querySelector('[data-pg-lista-more]');
    var dalej = lista.querySelector('[data-pg-lista-next]');
    if (!limit) {
      lista.classList.remove('is-otwarta');
      karty.forEach(function (k) { k.hidden = false; });
      if (wiecej) wiecej.hidden = true;
      return;
    }
    lista.classList.add('is-otwarta');
    karty.forEach(function (k, i) { k.hidden = i >= limit; });
    if (wiecej) wiecej.hidden = false;
    if (dalej) {
      var zostalo = karty.length - limit;
      dalej.hidden = zostalo <= 0;
      if (zostalo > 0) dalej.textContent = tekst(lista, 'data-next-wzor', Math.min(zostalo, KROK));
    }
  }
  /* 22.10.2026 (audyt B wiersz 16): od 5 pozycji serwer rysuje 3 karty (atrybut data-pg-lista-doczytaj); resztę bierzemy RAZ
     z sekcji pg-lista-reszta (jedno zapytanie na obie listy) i wstawiamy przed kafelkiem „Pokaż wszystkie” – dalej jak dotąd.
     Błąd sieci: lista rozwija się z tym, co jest, a następne kliknięcie próbuje ponownie. */
  var resztaZapytanie = null;
  function doczytaj(lista) {
    var rodzaj = lista.getAttribute('data-pg-lista-doczytaj');
    if (!rodzaj) return Promise.resolve();
    if (!resztaZapytanie) {
      resztaZapytanie = fetch(window.location.pathname + '?section_id=pg-lista-reszta', { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.text() : ''; })
        .then(function (html) { return html ? new DOMParser().parseFromString(html, 'text/html') : null; })
        .catch(function () { return null; });
    }
    return resztaZapytanie.then(function (doc) {
      if (!lista.hasAttribute('data-pg-lista-doczytaj')) return;
      var zrodlo = doc ? doc.querySelector('[data-pg-lista-reszta="' + rodzaj + '"]') : null;
      var siatka = lista.querySelector('.pg-lista__grid');
      if (!zrodlo || !siatka) { resztaZapytanie = null; return; }
      var kafel = siatka.querySelector('.pg-lista__all');
      Array.prototype.forEach.call(zrodlo.querySelectorAll('.pg-lista__item'), function (k) {
        siatka.insertBefore(document.importNode(k, true), kafel);
      });
      lista.removeAttribute('data-pg-lista-doczytaj');
    });
  }
  document.addEventListener('click', function (e) {
    var cel = e.target.closest ? e.target.closest('[data-pg-lista-all], [data-pg-lista-next], [data-pg-lista-less]') : null;
    if (!cel) return;
    var lista = cel.closest('.pg-lista');
    if (!lista) return;
    if (cel.hasAttribute('data-pg-lista-less')) {
      lista.setAttribute('data-limit', '0');
      odswiez(lista);
      lista.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      return;
    }
    var limit = parseInt(lista.getAttribute('data-limit') || '0', 10);
    if (lista.hasAttribute('data-pg-lista-doczytaj')) {
      if (lista.hasAttribute('aria-busy')) return;
      lista.setAttribute('aria-busy', 'true');
      doczytaj(lista).then(function () {
        lista.removeAttribute('aria-busy');
        lista.setAttribute('data-limit', String(limit + KROK));
        odswiez(lista);
      });
      return;
    }
    lista.setAttribute('data-limit', String(limit + KROK));
    odswiez(lista);
  });

  /* Stan startowy: komputer i tablet – tylko „Opis i dane techniczne” (listy zwinięte, rozwija je klient);
     telefon – pierwsza lista (opis stoi tam zawsze). To samo po zmianie szerokości okna. */
  function stanStartowy() {
    if (mqPasek.matches) { zwinWszystko(); return; }
    if (!pokaz('akcesoria')) pokaz('czesci');
  }
  stanStartowy();
  if (mqPasek.addEventListener) mqPasek.addEventListener('change', function () { stanStartowy(); przeniesOpinie(); });
  else if (mqPasek.addListener) mqPasek.addListener(function () { stanStartowy(); przeniesOpinie(); });
})();

;
/* ===== delivery-eta (v84) ===== */
/* Przewidywana wysyłka pod chipami na karcie produktu: element .pg-delivery-eta ze snippetu
   codext-shipping-time-badge-product-page (tam te same zasady i ta sama lista świąt w data-holidays).
   14.09 (Regulamin 4.1 §3 ust. 7): data-min/data-max = Dni robocze od dziś (bez sobót, niedziel i świąt);
   data-min 0 = „do …”; data-from (RRRR-MM-DD) = data dostępności – zakres od tej daty (albo od dziś, jeśli minęła)
   do data-max Dni roboczych po niej. */
/* 18.09 (krok B1): to samo liczenie obsługuje teraz dwa przypadki – zwykły i „ilość większa niż stan”
   (atrybuty data-min-over / data-max-over ze snippetu chipów). Funkcja window.pgEtaRender(over) przelicza
   linię na żądanie; część „lead-qty” woła ją przy każdej zmianie ilości. */
(function () {
  var el = document.querySelector('.pg-delivery-eta[data-max]');
  if (!el) return;
  var holidays = (el.getAttribute('data-holidays') || '').split(',');
  /* v85: skróty dni z języka strony (wersja EN sklepu: "Tue 15.09"), polskie jako zapas */
  var DAYS = ['niedz.', 'pn.', 'wt.', 'śr.', 'czw.', 'pt.', 'sob.'];
  var lang = (document.documentElement.lang || 'pl').slice(0, 2);
  var dayName = function (d) { return DAYS[d.getDay()]; };
  if (lang !== 'pl' && window.Intl && Intl.DateTimeFormat) {
    try {
      var dtf = new Intl.DateTimeFormat(lang, { weekday: 'short' });
      dayName = function (d) { return dtf.format(d); };
    } catch (e) {}
  }
  var pad = function (n) { return ('0' + n).slice(-2); };
  var ymd = function (d) { return d.getFullYear() + '-' + pad(d.getMonth() + 1) + '-' + pad(d.getDate()); };
  function isBusinessDay(d) {
    var wd = d.getDay();
    return wd !== 0 && wd !== 6 && holidays.indexOf(ymd(d)) === -1;
  }
  function addBusinessDays(from, n) {
    var d = new Date(from.getFullYear(), from.getMonth(), from.getDate());
    var left = n;
    while (left > 0) {
      d.setDate(d.getDate() + 1);
      if (isBusinessDay(d)) left -= 1;
    }
    return d;
  }
  var thisYear = new Date().getFullYear();
  function fmt(d) {
    return dayName(d) + ' ' + pad(d.getDate()) + '.' + pad(d.getMonth() + 1) + (d.getFullYear() !== thisYear ? '.' + d.getFullYear() : '');
  }
  function render(over) {
    var min = parseInt(el.getAttribute(over ? 'data-min-over' : 'data-min'), 10) || 0;
    var max = parseInt(el.getAttribute(over ? 'data-max-over' : 'data-max'), 10);
    /* przy ilości większej niż stan data dostępności nie obowiązuje – liczymy od dziś */
    var fromAttr = over ? '' : (el.getAttribute('data-from') || '');
    if (!(max > 0) || max < min) return;
    var now = new Date();
    var today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    var base = today;
    var a = null;
    if (/^\d{4}-\d{2}-\d{2}$/.test(fromAttr)) {
      var p = fromAttr.split('-');
      var from = new Date(+p[0], +p[1] - 1, +p[2]);
      if (from > today) base = from;
      a = new Date(base.getFullYear(), base.getMonth(), base.getDate());
      while (!isBusinessDay(a)) a.setDate(a.getDate() + 1);
    } else if (min > 0) {
      a = addBusinessDays(today, min);
    }
    var b = addBusinessDays(base, max);
    var label = el.getAttribute('data-label') || 'Przewidywana wysyłka';
    var daty = a ? fmt(a) + ' – ' + fmt(b) : (el.getAttribute('data-upto') || 'do') + ' ' + fmt(b);
    var text = label + ': ' + daty;
    /* v95 (CLS): Liquid wstawia już ten sam tekst (element widoczny od pierwszego malowania), więc zapis tylko
       przy różnicy – strona z pamięci podręcznej z innego dnia albo inna data w strefie czasowej klienta.
       18.09 (krok B2): tekst jest w osobnym `span`, żeby nadpisanie nie skasowało ikony zegara.
       S1 (makieta R11): daty są pogrubione („Przewidywana wysyłka: <b>czw. 17.09 – śr. 23.09</b>”),
       więc zapis składa etykietę i pogrubione daty z węzłów, bez innerHTML. */
    var cel = el.querySelector('[data-pg-eta-text]') || el;
    if (cel.textContent !== text) {
      cel.textContent = label + ': ';
      var gruby = document.createElement('b');
      gruby.textContent = daty;
      cel.appendChild(gruby);
    }
    el.hidden = false;
  }
  /* po zmianie wariantu motyw podmienia blok informacji (renderProductInfo), więc element trzeba odszukać
     od nowa – inaczej przeliczalibyśmy linię, której już nie ma w dokumencie */
  window.pgEtaRender = function (over) {
    var biezacy = document.querySelector('.pg-delivery-eta[data-max]');
    if (biezacy && biezacy !== el) {
      el = biezacy;
      holidays = (el.getAttribute('data-holidays') || '').split(',');
    }
    if (!el.isConnected) return;
    render(!!over && el.hasAttribute('data-max-over'));
  };
  render(false);
})();

;
/* ===== leaselink-a11y – PRZENIESIONY 22.09 do assets/pg-global.js =====
   Powód (axe, 22.09): kalkulator <leaselink-calculator> jest w kodzie strony także tam, gdzie NIE ma karty produktu
   (np. koszyk – panel stoi poza ekranem i czeka na otwarcie), a `pg-product.js` ładuje się tylko przy szablonie produktu,
   więc łatka nie działała i axe liczył na koszyku 21 naruszeń (image-alt 9, region 11, color-contrast 1) z cudzego widgetu. */

;
/* ===== leaselink-slot (v95) ===== */
/* slot LeaseLink bez przycisku nie może zostawiać pustego miejsca. 15.09 (B23 a):
   aplikacja ładuje się BEZ czekania na zgodę na cookies (dawny skrypt wyłączający sloty bez zgody usunięty z
   blocks/_product-buy-buttons.liquid), więc ta część obsługuje każdą wizytę:
   aplikacja (assets/pluginLL.js) ładuje się po pierwszej interakcji albo po 5 s (layout/theme.liquid);
   jeśli 12 s później w slocie nadal nie ma <leaselink-button> (bloker, błąd sieci, cena poniżej progu
   aplikacji, która wtedy czyści slot), slot dostaje data-pg-ll="off" i znika. Gdy przycisk pojawi się
   później, reguła :has w main-product.css przywraca slot. */
(function () {
  var slots = ['leaselink-desktop-slot', 'leaselink-mobile-slot']
    .map(function (id) { return document.getElementById(id); })
    .filter(Boolean);
  if (!slots.length) return;
  function check() {
    slots.forEach(function (slot) {
      if (slot.getAttribute('data-pg-ll') === 'off') return;
      if (!slot.querySelector('leaselink-button')) slot.setAttribute('data-pg-ll', 'off');
    });
  }
  var started = false;
  function start() {
    if (started) return;
    started = true;
    setTimeout(check, 12000);
  }
  ['scroll', 'click', 'touchstart', 'mousemove', 'keydown'].forEach(function (type) {
    window.addEventListener(type, start, { once: true, passive: true });
  });
  setTimeout(start, 5000);
})();

;
/* ===== recently-viewed – od 27.09 osobny plik `assets/pg-rvd.js` („DYMEK-1 A”, krok 43.26) =====
   Karuzela „Ostatnio oglądane” na dole karty zastąpiona dymkiem w lewym dolnym rogu; zapis historii (`pg_recently_viewed`, maks. 12)
   i pobranie listy przez wyszukiwarkę przeniesione tam bez zmian. Dawny kod (v84–21.09) – `_archive/motyw-43-26-przed-20260927T2312/assets/pg-product.js`. */

/* ===== gallery-defer (v93) ===== */
/* Galeria karty produktu (blocks/_product_swiper.liquid, .pm__main-swiper) ma efekt fade: wszystkie
   slajdy leżą na sobie w oknie, więc natywne loading="lazy" ładowało od razu wszystkie zdjęcia
   (9 × ~38 KB przy 375 px, ~80 KB przy 1920), choć widać tylko pierwsze. Slajdy 2+ dostają z Liquid
   src = 50 px oraz data-src/data-srcset (helper-image_sizes, parametr defer). Tu wstawiamy pełne adresy:
   dla sąsiedniego slajdu po załadowaniu strony w chwili bezczynności, dla aktywnego ±1 przy każdej
   zmianie slajdu (klasa swiper-slide-active, więc bez zależności od API Swipera motywu) i przy pierwszym
   dotknięciu / najechaniu na galerię albo miniatury. Zoom (PhotoSwipe) bierze pełny plik z
   data-original-src, więc podmiana go nie dotyczy. */
(function () {
  var gallery = document.querySelector('.pm__main-swiper');
  if (!gallery || !gallery.querySelector('img[data-pg-defer]')) return;

  function hydrate(slide, niski) {
    if (!slide) return;
    slide.querySelectorAll('img[data-pg-defer]').forEach(function (img) {
      if (niski) img.setAttribute('fetchpriority', 'low');
      var srcset = img.getAttribute('data-srcset');
      var src = img.getAttribute('data-src');
      if (srcset) img.setAttribute('srcset', srcset);
      if (src) img.setAttribute('src', src);
      img.removeAttribute('data-srcset');
      img.removeAttribute('data-src');
      img.removeAttribute('data-pg-defer');
    });
  }
  function slides() { return gallery.querySelectorAll('.swiper-slide'); }
  function around(index) {
    var all = slides();
    [index - 1, index, index + 1].forEach(function (i) {
      if (i >= 0 && i < all.length) hydrate(all[i]);
    });
  }
  function activeIndex() {
    var all = slides();
    for (var i = 0; i < all.length; i++) {
      if (all[i].classList.contains('swiper-slide-active')) return i;
    }
    return 0;
  }

  /* zmiana slajdu: Swiper przenosi klasę swiper-slide-active */
  new MutationObserver(function (muts) {
    for (var i = 0; i < muts.length; i++) {
      var t = muts[i].target;
      if (t.classList && t.classList.contains('swiper-slide') && t.classList.contains('swiper-slide-active')) {
        around(Array.prototype.indexOf.call(slides(), t));
      }
    }
  }).observe(gallery, { attributes: true, attributeFilter: ['class'], subtree: true });

  /* pierwszy kontakt z galerią lub miniaturami: aktywny ±1 od razu */
  var thumbs = document.querySelector('.pm__thumb-swiper');
  function onIntent() { around(activeIndex()); }
  [gallery, thumbs].forEach(function (el) {
    if (!el) return;
    ['touchstart', 'pointerdown', 'mouseenter', 'focusin', 'keydown'].forEach(function (ev) {
      el.addEventListener(ev, onIntent, { passive: true, once: true });
    });
  });

  /* po załadowaniu strony, w chwili bezczynności: drugi slajd, żeby pierwsze przesunięcie było ostre */
  function prefetchNext() { var all = slides(); if (all[1]) hydrate(all[1]); }
  function idle(fn) {
    if ('requestIdleCallback' in window) requestIdleCallback(fn, { timeout: 4000 }); else setTimeout(fn, 2000);
  }

  /* 26.09 (T8, K2 – pomiar 5.6 w `badania/2026-09-26-zdjecia-ladowanie-525.md`): skok miniaturą pokazywał przez 0,34–0,53 s
     powiększony plik 50 px – pełny plik ruszał dopiero przy kliknięciu, a przy pierwszym wejściu w wariant CDN odpowiada 0,4–0,6 s. Teraz rusza wcześniej:
     (1) najechanie, dotknięcie albo fokus (Tab) miniatury – od razu jej slajd (najechanie wyprzedza kliknięcie o ok. 100–300 ms);
     (2) po wczytaniu strony, w bezczynności, po jednym i z niskim priorytetem – przy myszy slajdy miniatur widocznych w zwiniętym pasku (do 8),
         na ekranach dotykowych dwa kolejne za aktywnym; przy oszczędzaniu danych (Save-Data) – tylko (1). Pierwszego zdjęcia (LCP) to nie dotyczy. */
  if (thumbs) {
    var naKciuk = function (e) {
      var k = e.target && e.target.closest ? e.target.closest('.ProductSlider--Thumb') : null;
      if (k) hydrate(slides()[Array.prototype.indexOf.call(thumbs.querySelectorAll('.ProductSlider--Thumb'), k)]);
    };
    ['pointerover', 'touchstart', 'focusin'].forEach(function (ev) { thumbs.addEventListener(ev, naKciuk, { passive: true }); });
  }
  function wyprzedz() {
    if (navigator.connection && navigator.connection.saveData) return;
    var all = slides(), kolejka = [];
    if (thumbs && window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
      var pas = thumbs.getBoundingClientRect();
      Array.prototype.forEach.call(thumbs.querySelectorAll('.ProductSlider--Thumb'), function (k, i) {
        var r = k.getBoundingClientRect();
        if (i < 8 && r.width > 0 && r.left >= pas.left - 1 && r.right <= pas.right + 1) kolejka.push(i);
      });
    } else {
      var a = activeIndex();
      kolejka = [a + 1, a + 2];
    }
    (function nastepny() {
      var i = kolejka.shift();
      if (i === undefined) return;
      var img = all[i] ? all[i].querySelector('img[data-pg-defer]') : null;
      if (!img) { nastepny(); return; }
      var gotowe = false;
      var dalej = function () { if (gotowe) return; gotowe = true; idle(nastepny); };
      img.addEventListener('load', dalej, { once: true });
      img.addEventListener('error', dalej, { once: true });
      setTimeout(dalej, 4000); /* zapas: zdjęcie, które się nie wczytuje, nie wstrzymuje kolejki */
      hydrate(all[i], true);
    })();
  }
  function poWczytaniu() { prefetchNext(); wyprzedz(); }
  if (document.readyState === 'complete') idle(poWczytaniu);
  else window.addEventListener('load', function () { idle(poWczytaniu); }, { once: true });
})();

/* ===== gw-slot (6.H2) ===== */
/* Rezerwacja miejsca na przycisk CartBite „Powiadom mnie” (span .pg-gw-slot z snippets/product-form.liquid,
   reguły w base-min.css). Gdy przycisk przyjdzie, rezerwację chowa sam CSS (:has). Tu tylko sprzątanie: span
   znika, gdy przycisku nie ma 8 s po zdarzeniu load (aplikacja wyłączona albo zablokowana – bez pustego
   prostokąta) i tak samo 8 s po zmianie wariantu (motyw podmienia wtedy zawartość wrappera razem ze spanem). */
(function () {
  function sweep() {
    [].forEach.call(document.querySelectorAll('.pg-gw-slot'), function (s) {
      var w = s.parentNode;
      if (w && !w.querySelector('.gw-button-widget')) w.removeChild(s);
    });
  }
  function later() { setTimeout(sweep, 8000); }
  if (document.readyState === 'complete') later();
  else window.addEventListener('load', later, { once: true });
  document.addEventListener('variant:changed', later, true);
})();

/* ===== blok „Do pobrania” – 25.09 (T8): przycisk „Pokaż wszystkie pliki (N)” USUNIĘTY razem z tym modułem – wszystkie pliki widać od razu
   (snippets/pg-pliki.liquid). Dawny kod (17.09 / 21.09) – _archive/motyw-482-przed/pg-product.js. */

/* ===== „Inni kupowali razem” (17.09, mandat B75) =====
   Karuzela z metapola prime.kupowane_razem jest renderowana przez Liquid (snippets/pg-kupowane-razem.liquid),
   więc nie ma nad sobą własnego elementu, który uruchomiłby Swipera – robimy to tutaj (tak samo było przy
   karuzeli „Ostatnio oglądane” do 27.09). Blok leży daleko pod zgięciem, więc inicjalizacja niczym nie przesuwa widoku (CLS),
   a do jej czasu style .pg-kr w main-product.css układają karty w rząd. Gdy Swipera nie ma (błąd skryptu
   motywu), zostaje rząd z przewijaniem palcem – karuzela nigdy nie zamienia się w kolumnę na cały ekran. */
(function () {
  var swiperEl = document.querySelector('[data-pg-kupowane-razem] .pg-kr__swiper');
  if (!swiperEl) return;
  var prob = 0;
  function init() {
    if (swiperEl.classList.contains('swiper-initialized')) return;
    if (typeof RevolutionSwiper === 'function') {
      try { new RevolutionSwiper(swiperEl); } catch (e) { /* zostaje rząd z CSS */ }
      return;
    }
    if (++prob < 25) setTimeout(init, 200); /* skrypt motywu bywa odroczony (DEFER w theme.liquid) */
  }
  /* 21.09 (krok 7.1, K7-8): start Swipera dopiero 1 200 px przed ekranem (blok stoi pod zgięciem; do tego czasu karty
     układa CSS .pg-kr w rząd, a zapas 1 200 px sprawia, że start dzieje się poza ekranem); bez obserwatora – przy load, jak dotąd */
  function schedule() {
    if (!('IntersectionObserver' in window)) { init(); return; }
    var krIo = new IntersectionObserver(function (entries) {
      if (entries.some(function (e) { return e.isIntersecting; })) { krIo.disconnect(); init(); }
    }, { rootMargin: '1200px 0px' });
    krIo.observe(swiperEl);
  }
  if (document.readyState === 'complete') schedule();
  else window.addEventListener('load', schedule, { once: true });
})();

;
/* ===== leasing: nasz przycisk finansowania z kwotą raty (18.09, krok B4 planu 211) =====
   Klient widzi przycisk z kwotą policzoną w Liquid (snippets/pg-leasing.liquid). Skrypt wtyczki LeaseLink
   wczytujemy DOPIERO po kliknięciu – do tego czasu karta nie pobiera niczego z leaselink.pl (makieta 4.4,
   Polityka prywatności 3.1). Po wczytaniu wtyczka wystawia swój przycisk w niewidocznym slocie; klikamy go
   programowo, co otwiera kalkulator (sprawdzone: element `leaselink-calculator` dostaje `is-opened`).
   Gdy wtyczka nie dojdzie (bloker, brak sieci), przycisk wraca do stanu wyjściowego i nic się nie psuje. */
(function () {
  if (window.__pgLeasing) return;
  window.__pgLeasing = true;

  var wTrakcie = false;

  function wczytajSkrypt(src) {
    return new Promise(function (res, rej) {
      if (document.querySelector('script[src="' + src + '"]')) return res();
      var s = document.createElement('script');
      s.src = src;
      s.async = true;
      s.onload = function () { res(); };
      s.onerror = function () { rej(new Error('nie udało się wczytać wtyczki')); };
      document.body.appendChild(s);
    });
  }

  function poczekajNaPrzycisk(ms) {
    var koniec = Date.now() + ms;
    return new Promise(function (res, rej) {
      (function sprawdz() {
        var b = document.querySelector('#leaselink-desktop-slot leaselink-button, #leaselink-mobile-slot leaselink-button');
        if (b) return res(b);
        if (Date.now() > koniec) return rej(new Error('wtyczka nie wystawiła przycisku'));
        setTimeout(sprawdz, 120);
      })();
    });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest ? e.target.closest('[data-pg-leasing-btn]') : null;
    if (!btn || wTrakcie) return;
    e.preventDefault();
    wTrakcie = true;
    var nazwa = btn.querySelector('.pg-leasing__nazwa');
    var pierwotny = nazwa ? nazwa.textContent : '';
    var czekam = btn.getAttribute('data-pg-leasing-czekam');
    if (nazwa && czekam) nazwa.textContent = czekam;
    btn.classList.add('pg-leasing__btn--czeka');

    var src = btn.getAttribute('data-pg-leasing-src');
    wczytajSkrypt(src)
      .then(function () { return poczekajNaPrzycisk(8000); })
      .then(function (b) { b.click(); })
      .catch(function () { /* bez wtyczki nie otwieramy nic – przycisk wraca do stanu wyjściowego */ })
      .then(function () {
        if (nazwa && pierwotny) nazwa.textContent = pierwotny;
        btn.classList.remove('pg-leasing__btn--czeka');
        wTrakcie = false;
      });
  });
})();

;
/* ===== lead-qty: ilość większa niż stan (18.09, krok B1 planu 211; od 28.10 bez stanu magazynu w stronie) =====
   Gdy klient wpisze więcej sztuk, niż mamy w magazynie, termin „2–6 dni roboczych” przestaje obowiązywać
   (Regulamin §3 ust. 7). Do 27.10 skrypt porównywał ilość z liczbą sztuk z atrybutu komunikatu i przełączał razem
   komunikat, chip „Realizacja: …”, „Przewidywaną wysyłkę” i ukrytą właściwość `properties[_Termin realizacji]`.
   28.10 liczba sztuk nie trafia już do strony, więc karta nie wie, przy jakiej ilości termin się zmienia.
   Przy ilości od 2 sztuk pokazujemy ogólny komunikat (snippets/pg-ilosc-uwaga.liquid, klucz pg.qty_note_card_html):
   termin może być dłuższy, dokładny pokaże koszyk. Chip, „Przewidywana wysyłka” i właściwość pozycji zostają zwykłe;
   dokładny termin dla ilości liczy Liquid w koszyku, a właściwość pozycji poprawia tam assets/pg-global.js (część
   „cart-lead”, także przed kasą z „Kup teraz”). Po zmianie wariantu motyw podmienia bloki (renderProductInfo), więc
   komunikat szukamy od nowa przy każdym przeliczeniu. */
(function () {
  if (window.__pgLeadQty) return;
  window.__pgLeadQty = true;

  function przelicz() {
    var uwaga = document.querySelector('[data-pg-qty-note]');
    var pole = document.querySelector('.pm__quantity-input');
    if (!uwaga || !pole) return;
    var ilosc = parseInt(pole.value, 10);
    if (!(ilosc > 0)) return;
    uwaga.hidden = !(ilosc > 1);
  }

  function pozniej() { setTimeout(przelicz, 60); }

  /* pole ilości zmienia się na trzy sposoby: wpisaniem, przyciskami +/− motywu (bez zdarzeń – pułapka z v83)
     i przez pasek zakupu (ten sam input, więc wystarczy nasłuch na dokumencie) */
  document.addEventListener('input', function (e) {
    if (e.target && e.target.classList && e.target.classList.contains('pm__quantity-input')) przelicz();
  }, true);
  document.addEventListener('change', function (e) {
    if (e.target && e.target.classList && e.target.classList.contains('pm__quantity-input')) przelicz();
  }, true);
  document.addEventListener('click', function (e) {
    if (e.target && e.target.closest && e.target.closest('.pm__quantity-button')) pozniej();
  }, true);
  /* zmiana wariantu: inny stan magazynowy i inne teksty – motyw podmienia bloki, więc liczymy po podmianie */
  document.addEventListener('variant:changed', pozniej, true);

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', przelicz);
  else przelicz();
})();

;
/* ===== opis-wiecej (S1, 18.09; makieta R11 `.v7c-desc` + „Pokaż więcej”, rozstrzygnięcie K-17) =====
   Na komputerze opis stoi obok danych technicznych; gdy jest wyraźnie dłuższy od tabeli (> 60 px), przycinamy go do
   wysokości tabeli (z wygaszeniem) i dokładamy „Pokaż więcej”. Tabela krótsza niż 400 px – bez przycinania (kilka
   wierszy danych nie może chować prawie całego opisu). ZABEZPIECZENIE PRZED SKOKIEM PRZEWIJANIA (pułapka v76 –
   dawne equalize() zmieniało wysokości w trakcie przewijania): wysokość ustawiamy tylko wtedy, gdy sekcja jest
   jeszcze pod górną krawędzią okna (klient jej nie minął), albo po jego własnym kliknięciu i zmianie szerokości okna. */
(function () {
  var sekcja = document.getElementById('product-info');
  if (!sekcja) return;
  var pane = sekcja.querySelector('.pg-sek__pane--opis');
  if (!pane) return;
  var kolumny = pane.querySelectorAll(':scope > .Dropdown');
  if (kolumny.length < 2) return;
  var opis = kolumny[0].querySelector('.Dropdown--Content');
  var dane = kolumny[1].querySelector('.Dropdown--Content');
  if (!opis || !dane) return;
  var mq = window.matchMedia('(min-width: 1024px)');
  var przycisk = document.createElement('button');
  przycisk.type = 'button';
  przycisk.className = 'pg-opis__wiecej pg-wiecej-btn'; /* 797 T2 */
  przycisk.hidden = true;
  przycisk.setAttribute('aria-expanded', 'false');
  przycisk.setAttribute('aria-controls', opis.id || '');
  przycisk.textContent = sekcja.getAttribute('data-more') || 'Pokaż więcej';
  kolumny[0].appendChild(przycisk);
  var rozwiniety = false;

  function ustaw(sila) {
    /* 25.09 12:0x (krok 30.9 d etap 3): stan „bez przycinania” (telefon albo rozwinięty), w którym NIC nie trzeba zmieniać – koniec BEZ odczytu
       układu (dawniej `getBoundingClientRect` szedł pierwszy i na telefonie wymuszał przeliczenie układu przy każdym wywołaniu – profil: 300 ms
       czasu własnego przy ×4); gdy coś jest do zmiany – dalej jak dotąd (najpierw sprawdzenie, czy klient nie minął sekcji). */
    if ((!mq.matches || rozwiniety) && opis.style.maxHeight === '' && !opis.classList.contains('pg-opis--ciete') && przycisk.hidden === !(rozwiniety && mq.matches)) return;
    if (!sila && sekcja.getBoundingClientRect().top < 0) return; /* klient jest już niżej – nie ruszamy wysokości */
    if (!mq.matches || rozwiniety) {
      opis.style.maxHeight = '';
      opis.classList.remove('pg-opis--ciete');
      przycisk.hidden = !(rozwiniety && mq.matches);
      return;
    }
    var hTabeli = dane.offsetHeight;
    opis.style.maxHeight = '';
    var hOpisu = opis.scrollHeight;
    if (hTabeli >= 400 && hOpisu > hTabeli + 60) {
      opis.style.maxHeight = hTabeli + 'px';
      opis.classList.add('pg-opis--ciete');
      przycisk.hidden = false;
    } else {
      opis.classList.remove('pg-opis--ciete');
      przycisk.hidden = true;
    }
  }

  przycisk.addEventListener('click', function () {
    rozwiniety = !rozwiniety;
    przycisk.setAttribute('aria-expanded', rozwiniety ? 'true' : 'false');
    przycisk.textContent = rozwiniety ? (sekcja.getAttribute('data-less') || 'Pokaż mniej') : (sekcja.getAttribute('data-more') || 'Pokaż więcej');
    ustaw(true);
    if (!rozwiniety) kolumny[0].scrollIntoView({ block: 'start' });
  });

  ustaw(false);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { ustaw(false); });
  window.addEventListener('load', function () { ustaw(false); });
  var czekaj;
  window.addEventListener('resize', function () {
    clearTimeout(czekaj);
    czekaj = setTimeout(function () { ustaw(true); }, 250);
  });
})();

;
/* ===== galeria-wiecej (S1, 18.09; makieta R11 – szósta miniatura „+N”; PRZEBUDOWA 25.09 – T9) =====
   Pasek miniatur pod zdjęciem (tablet i komputer): zwinięty pokazuje tyle miniatur, ile mieści się w całości (5–8 – CSS `@container pg-kciuki`),
   a ostatnia widoczna ma nakładkę „+N” (blocks/_product_swiper.liquid). Właściciel 25.09: „powinno raczej wewnątrz slidera je otworzyć,
   przesunąć slider tak aby to kolejne nowe było po lewej i było otwarte jako zdjęcie […] jak sie nie mieszczą to 3cie albo 2gie od konca
   przesuwa slider […] dac sie przesuwać ręcznie oraz samo sie przesuwac”. Dlatego (zamiast okna powiększenia z 18.09):
   (1) wybór zdjęcia „+N” (klik, klawiatura albo przejście strzałką zdjęcia) ROZWIJA pasek – klasa `pg-kciuki--rozwiniete` pokazuje wszystkie
       miniatury (CSS), nakładka znika, a pasek przesuwa się tak, że to zdjęcie stoi po lewej;
   (2) przy każdej zmianie zdjęcia pasek przesuwa się sam z wyprzedzeniem: gdy bieżąca miniatura jest ostatnią albo przedostatnią widoczną,
       staje jako druga od lewej (widać kolejne); wstecz – jako druga od prawej;
   (3) ręcznie: przeciąganie paska (Swiper), strzałki paska (tylko po rozwinięciu, tylko w stronę, gdzie są dalsze miniatury), klawisz Enter/spacja
       na miniaturze wybiera zdjęcie. Zmiana następuje wyłącznie po działaniu klienta (B126); wysokość paska stała – bez przesunięć układu. */
(function () {
  if (window.__pgGaleriaWiecej) return;
  window.__pgGaleriaWiecej = true;
  var szeroki = window.matchMedia('(min-width: 768px)');
  function box() { return document.querySelector('.pm__media-slideshow .product_slider-thumbnails'); }
  function kciuki() { var e = document.querySelector('.pm__media-slideshow .pm__thumb-swiper'); return e && e.swiper; }
  function glowny() { var e = document.getElementById('productSwiperElement'); return e && e.swiper; }
  /* indeks miniatury z „+N” przy bieżącej szerokości paska = ostatnia widoczna w zwiniętym pasku (od niej pasek musi być rozwinięty);
     liczone z tego, co CSS pokazuje, a nie z nakładki – nakładka aktywnej miniatury jest ukryta */
  function progWiecej() {
    var b = box(); if (!b || !szeroki.matches) return Infinity;
    var s = b.querySelectorAll('.pm__thumb-swiper .ProductSlider--Thumb'), d = 0;
    for (var i = 0; i < s.length; i++) if (window.getComputedStyle(s[i]).display !== 'none') d++;
    return d > 0 && d < s.length ? d - 1 : Infinity;
  }
  function rozwiniety() { var b = box(); return !!(b && b.classList.contains('pg-kciuki--rozwiniete')); }
  /* zakres miniatur w pełni widocznych w okienku paska: [pierwsza, ostatnia] */
  function widoczne(t) {
    var f = -1, l = -1;
    for (var i = 0; i < t.slides.length; i++) {
      var s = t.slidesSizesGrid[i]; if (!s) continue;
      var x = t.slidesGrid[i] + t.translate;
      if (x >= -1 && x + s <= t.width + 1) { if (f < 0) f = i; l = i; }
    }
    return [f, l];
  }
  function strzalki() {
    var b = box(), t = kciuki(); if (!b || !t) return;
    var wl = rozwiniety() && szeroki.matches;
    var sl = b.querySelector('[data-pg-kciuki-strz="-1"]'), sp = b.querySelector('[data-pg-kciuki-strz="1"]');
    if (sl) sl.hidden = !wl || t.isBeginning;
    if (sp) sp.hidden = !wl || t.isEnd;
  }
  function rozwin() {
    var b = box(), t = kciuki(); if (!b || !t || rozwiniety()) return false;
    b.classList.add('pg-kciuki--rozwiniete');
    t.update();
    return true;
  }
  var poprzedni = null;
  function dopasuj(a) {
    var t = kciuki(); if (!t) return;
    var prog = progWiecej();
    if (!rozwiniety() && a >= prog) {                 /* wybrane zdjęcie „+N” albo dalsze: rozwiń i postaw je po lewej */
      rozwin(); t.slideTo(Math.max(0, a === prog ? a : a - 1)); poprzedni = a; setTimeout(strzalki, 350); return;
    }
    var v = widoczne(t), f = v[0], l = v[1], n = t.slides.length;
    if (f < 0) { poprzedni = a; return; }
    var ile = l - f + 1, cel = null;
    var wPrzod = poprzedni === null || a >= poprzedni;
    if (a < f || a > l) cel = wPrzod ? a - 1 : a - (ile - 2);                 /* bieżąca poza okienkiem */
    else if (wPrzod && a >= l - 1 && l < n - 1) cel = a - 1;                  /* ostatnia / przedostatnia widoczna – pokaż kolejne */
    else if (!wPrzod && a <= f + 1 && f > 0) cel = a - (ile - 2);             /* pierwsza / druga widoczna przy cofaniu – pokaż wcześniejsze */
    if (cel !== null) { cel = Math.max(0, Math.min(cel, n - 1)); if (cel !== f) t.slideTo(cel); }
    poprzedni = a;
    setTimeout(strzalki, 350);
  }
  function podlacz() {
    var g = glowny(), t = kciuki();
    if (!g || !t) return false;
    if (g.__pgKciuki) return true;
    g.__pgKciuki = true;
    poprzedni = g.activeIndex;
    g.on('slideChange', function () { dopasuj(g.activeIndex); });
    t.on('slideChange transitionEnd resize', strzalki);
    var b = box();
    if (b) b.addEventListener('click', function (e) {
      var s = e.target && e.target.closest ? e.target.closest('[data-pg-kciuki-strz]') : null;
      if (!s) return;
      var kier = Number(s.getAttribute('data-pg-kciuki-strz')) || 1, v = widoczne(t), ile = Math.max(1, v[1] - v[0]);
      t.slideTo(Math.max(0, Math.min(t.slides.length - 1, (v[0] < 0 ? 0 : v[0]) + kier * ile)));
      setTimeout(strzalki, 350);
    });
    strzalki();
    return true;
  }
  /* galeria startuje w skrypcie motywu (element produktu tworzy Swipera przy podłączeniu – na wolnym urządzeniu bywa to kilkanaście sekund po wczytaniu).
     25.09 (test galerii 482): samo odpytywanie przez 10 s przegrywało z wolnym startem i pasek się nie rozwijał, dlatego podłączenie idzie przy zmianie
     klas obu elementów galerii (Swiper dopisuje swoje klasy przy starcie) i przy pierwszym dotknięciu / klawiszu w galerii; odpytywanie zostaje jako zapas. */
  if (!podlacz()) {
    var cele = document.querySelectorAll('#productSwiperElement, .pm__media-slideshow .pm__thumb-swiper');
    if (cele.length && window.MutationObserver) {
      var obs = new MutationObserver(function () { if (podlacz()) obs.disconnect(); });
      for (var c = 0; c < cele.length; c++) obs.observe(cele[c], { attributes: true, attributeFilter: ['class'] });
    }
    var galeria = document.querySelector('.pm__media-slideshow');
    if (galeria) ['pointerdown', 'keydown'].forEach(function (typ) { galeria.addEventListener(typ, podlacz, true); });
    var proby = 0;
    (function czekaj() { if (podlacz() || ++proby > 40) return; setTimeout(czekaj, 250); })();
  }
  /* klawiatura: Enter / spacja na miniaturze = wybór zdjęcia (miniatury mają tabindex="0") */
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' && e.key !== ' ') return;
    var k = e.target && e.target.closest ? e.target.closest('.pm__media-slideshow .ProductSlider--Thumb') : null;
    if (!k) return;
    var g = glowny(); if (!g) return;
    e.preventDefault();
    g.slideTo(Array.prototype.indexOf.call(k.parentNode.children, k));
  });
  window.addEventListener('resize', function () { setTimeout(strzalki, 300); });
})();

;
/* ===== etykieta-nazwa (19.09, D5/E2 – axe link-name) =====
   Aplikacja etykiet energetycznych (blok w `.pg-buy__energia`) wstawia link do karty informacyjnej produktu, którego napis
   („Karta informacyjna produktu”) istnieje tylko w CSS aplikacji (::before) – link nie ma nazwy dla czytnika ekranu (WCAG F87).
   Po wstawieniu przez aplikację dopisujemy aria-label z tego samego napisu (2.5.3 – nazwa zawiera widoczny tekst). Obserwujemy
   tylko miejsce bloku aplikacji na karcie, nie całą stronę. */
(function () {
  var miejsce = document.querySelector('.pg-buy__energia');
  if (!miejsce) return;
  function napraw() {
    miejsce.querySelectorAll('a.energy-badge__link:not([aria-label])').forEach(function (a) {
      if (a.textContent.trim()) return;
      var t = '';
      a.querySelectorAll('span').forEach(function (s) {
        ['::before', '::after'].forEach(function (p) {
          var c = getComputedStyle(s, p).content;
          if (c && c !== 'none' && c !== 'normal') t += c.replace(/^["']|["']$/g, '');
        });
      });
      if (t.trim()) a.setAttribute('aria-label', t.trim());
    });
  }
  napraw();
  if ('MutationObserver' in window) new MutationObserver(napraw).observe(miejsce, { childList: true, subtree: true });
})();


/* ===== rodzina: „Pokaż pozostałe (N)” (21.09, T10) =====
   Przy rodzinie dłuższej niż 10 wariantów widać pierwsze 10 kafelków, resztę pokazuje przycisk.
   Stan zwinięty robi CSS (`.pg-rodz__li--ukryty`), więc bez skryptu nic nie znika na stałe – po prostu
   przycisk nic nie robi. Po rozwinięciu przycisk chowa się (nie ma czego zwijać z powrotem). */
(function () {
  document.addEventListener('click', function (e) {
    var b = e.target.closest ? e.target.closest('[data-pg-rodz-wiecej]') : null;
    if (!b) return;
    var box = b.closest('.pg-rodz');
    if (!box) return;
    box.classList.add('is-otwarta');
    b.setAttribute('aria-expanded', 'true');
  });
})();


/* ===== osie – filtr wersji (27.09, – WERSJA-1 R3; snippets/pg-osie.liquid, tryb „Wersja”) =====
   Przycisk nad listą „Wersja” pokazuje tylko wersje z tą wartością osi (np. „GN1/4”), „Wszystkie” – całą listę; kliknięcie otwiera listę,
   żeby klient od razu widział skutek (B126 – zmiana tylko po kliknięciu). Stan startowy (wartość oglądanego produktu) jest w HTML z serwera,
   wiersze chowa CSS `.js .pg-osie__poza` – bez skryptu filtr jest ukryty, a lista pełna. */
(function () {
  document.addEventListener('click', function (e) {
    var b = e.target.closest ? e.target.closest('[data-pg-osie-f]') : null;
    if (!b) return;
    var box = b.closest('.pg-osie__os');
    if (!box) return;
    var v = b.getAttribute('data-pg-osie-f');
    box.querySelectorAll('[data-pg-osie-f]').forEach(function (x) { x.setAttribute('aria-pressed', String(x === b)); });
    box.querySelectorAll('li[data-pg-osie-fw]').forEach(function (li) {
      li.classList.toggle('pg-osie__poza', !(v === '*' || li.getAttribute('data-pg-osie-fw') === v));
    });
    var d = box.querySelector('details.pg-rodz__wybor');
    if (d && !d.open) d.open = true;
  });
})();


/* ===== zoom-najechanie (21.09, T1; rejestr rekomendacji R-1) =====
   Właściciel: „po najechaniu na zdjęciu miał się robić zoom, że to dobra praktyka, a ty tego nie zrobiłeś”. Baymard 2026: 56 % klientów
   zaczyna kartę od zdjęć, a ok. 25 % sklepów ma za słabe powiększenie. Do 21.09 zdjęcie powiększało się tylko po kliknięciu (okno motywu).
   Teraz na komputerze (mysz, okno od 1 024 px) najechanie na zdjęcie pokazuje W TYM SAMYM POLU powiększenie 2,2×, które podąża za kursorem;
   kliknięcie nadal otwiera okno powiększenia, klawiatura i telefon – bez zmian. Zasady: (1) ostre źródło – wariant 1 800 px z CDN Shopify,
   pobierany DOPIERO przy pierwszym najechaniu na dane zdjęcie (nic nie dochodzi do startu strony); (2) 120 ms zwłoki, żeby przejazd kursora
   przez galerię niczego nie włączał; (3) warstwa leży w polu zdjęcia (position: absolute) – zero przesunięć układu; (4) slajdy z filmem
   albo modelem są pomijane; (5) warstwa nie przechwytuje kliknięć (pointer-events: none). */
(function () {
  if (window.__pgZoomNajechanie) return;
  window.__pgZoomNajechanie = true;
  var galeria = document.getElementById('productSwiperElement');
  if (!galeria || !window.matchMedia) return;
  var mysz = window.matchMedia('(hover: hover) and (pointer: fine) and (min-width: 1024px)');
  var SKALA = 2.2, ZWLOKA = 120;
  var pole = null, warstwa = null, zegar = 0, gotowe = {}, ostatni = null;

  function duzyAdres(img) {
    var src = img.currentSrc || img.src || '';
    if (!src || src.indexOf('data:') === 0) return '';
    try {
      var u = new URL(src, location.href);
      u.searchParams.set('width', '1800');
      u.searchParams.delete('height');
      u.searchParams.delete('crop');
      return u.toString();
    } catch (e) { return ''; }
  }
  function ustaw(e) {
    if (!pole || !warstwa) return;
    var img = pole.querySelector('img.ProductSlider--Image');
    if (!img || !img.naturalWidth) return;
    var r = pole.getBoundingClientRect();
    var W = r.width, H = r.height;
    var k = Math.min(W / img.naturalWidth, H / img.naturalHeight);
    var w = img.naturalWidth * k, h = img.naturalHeight * k; /* zdjęcie wpisane w pole (object-fit: contain) */
    var ox = (W - w) / 2, oy = (H - h) / 2;
    var mx = e.clientX - r.left, my = e.clientY - r.top;
    var rx = Math.max(0, Math.min(1, (mx - ox) / w)), ry = Math.max(0, Math.min(1, (my - oy) / h));
    warstwa.style.backgroundSize = Math.round(w * SKALA) + 'px ' + Math.round(h * SKALA) + 'px';
    warstwa.style.backgroundPosition = Math.round(mx - rx * w * SKALA) + 'px ' + Math.round(my - ry * h * SKALA) + 'px';
  }
  function wylacz() {
    clearTimeout(zegar);
    if (warstwa) warstwa.classList.remove('is-on');
    pole = null;
  }
  function wlacz(nowe, e) {
    var img = nowe.querySelector('img.ProductSlider--Image');
    if (!img || nowe.querySelector('video, iframe, model-viewer')) return;
    var adres = duzyAdres(img);
    if (!adres) return;
    pole = nowe;
    warstwa = nowe.querySelector('.pg-zoom-warstwa');
    if (!warstwa) {
      warstwa = document.createElement('div');
      warstwa.className = 'pg-zoom-warstwa';
      warstwa.setAttribute('aria-hidden', 'true');
      nowe.appendChild(warstwa);
    }
    function pokaz() {
      if (pole !== nowe) return;
      warstwa.style.backgroundImage = 'url("' + adres + '")';
      ustaw(ostatni || e);
      warstwa.classList.add('is-on');
    }
    if (gotowe[adres]) { pokaz(); return; }
    var duzy = new Image();
    duzy.onload = function () { gotowe[adres] = true; pokaz(); };
    duzy.src = adres;
  }
  galeria.addEventListener('mousemove', function (e) {
    if (!mysz.matches) return;
    ostatni = e;
    var cel = e.target && e.target.closest ? e.target.closest('.ProductSliderCell--Zoom .ProductSlider--Element') : null;
    if (e.target.closest && e.target.closest('button, a, [role="button"]')) cel = null; /* przyciski na zdjęciu (lupa, porównanie) */
    if (!cel) { if (pole) wylacz(); return; }
    if (cel === pole) { ustaw(e); return; }
    wylacz();
    zegar = setTimeout(function () { wlacz(cel, e); }, ZWLOKA);
  }, { passive: true });
  galeria.addEventListener('mouseleave', wylacz, { passive: true });
  galeria.addEventListener('mousedown', wylacz, { passive: true }); /* kliknięcie otwiera okno powiększenia – warstwa znika */
})();

/* ===== kopiuj-link (21.09, etap 19, rejestr rekomendacji R-12) =====
   Przycisk „Kopiuj link” obok „Drukuj” (blocks/_product-trust-items.liquid). Kopiuje adres KANONICZNY karty (bez parametrow podgladu
   i sledzenia). Przycisk jest w kodzie ukryty i pokazuje sie tylko tam, gdzie przegladarka ma schowek (navigator.clipboard) – bez
   martwego przycisku. Po skopiowaniu napis zmienia sie na 2 s (aria-live w znaczniku), bez zmiany szerokosci wiersza ponad slowo. */
(function () {
  var b = document.querySelector('[data-pg-kopiuj-link]');
  if (!b || !navigator.clipboard || !navigator.clipboard.writeText) return;
  var sep = document.querySelector('[data-pg-kopiuj-sep]');
  var napis = b.querySelector('[data-pg-kopiuj-napis]');
  var zwykly = napis ? napis.textContent : '';
  b.hidden = false; if (sep) sep.hidden = false;
  var zegar = null;
  b.addEventListener('click', function () {
    var k = document.querySelector('link[rel="canonical"]');
    var adres = k && k.href ? k.href : location.origin + location.pathname;
    navigator.clipboard.writeText(adres).then(function () {
      if (!napis) return;
      napis.textContent = b.getAttribute('data-t-ok') || zwykly;
      clearTimeout(zegar);
      zegar = setTimeout(function () { napis.textContent = zwykly; }, 2000);
    }).catch(function () { /* brak zgody przegladarki na schowek – napis zostaje */ });
  });
})();

/* ===== atc-ladowanie (21.09, etap 19 / krok 18.5, znalezisko W-16) =====
   Pomiar na podgladzie: od klikniecia "Dodaj do koszyka" do otwarcia szuflady mija 1,2-1,7 s (0,5-0,8 s to odpowiedz sklepu na add.js,
   potem pobranie sekcji szuflady i jej start), a przycisk przez ten czas wygladal tak samo - motyw tylko go blokuje (disabled), bez zmiany
   wygladu. Klient nie wiedzial, czy klikniecie zadzialalo. Od klikniecia przycisk (glowny i w lepkim pasku) pokazuje kolko ladowania
   w miejscu ikony koszyka (style: main-product.css, klasa pg-atc-laduje); konczy sie, gdy szuflada sie otwiera (body.scrollLock),
   albo po 5 s. Bez zmiany ukladu: kolko ma wymiar ikony. */
(function () {
  var SEL = '.pm__atc-button--main, [data-sticky-atc]';
  document.addEventListener('click', function (e) {
    var b = e.target && e.target.closest ? e.target.closest(SEL) : null;
    /* 25.09 (523 T3): „Skontaktuj się” produktu „tylko kontakt” (pg-tk-button) nie dodaje do koszyka – bez kółka ładowania */
    if (!b || b.disabled || b.classList.contains('pg-atc-laduje') || b.classList.contains('pg-tk-button')) return;
    b.classList.add('pg-atc-laduje');
    /* koniec TYLKO przy otwarciu szuflady albo po 5 s: motyw odblokowuje przycisk zaraz po odpowiedzi add.js, a szuflada otwiera sie
       dopiero ok. 0,4 s pozniej - pierwsza wersja (koniec przy odblokowaniu) gasila kolko przed czasem (zrzut z82, 21.09) */
    var zegar = null, obsBody = null;
    var koniec = function () {
      b.classList.remove('pg-atc-laduje');
      if (obsBody) obsBody.disconnect();
      clearTimeout(zegar);
    };
    obsBody = new MutationObserver(function () { if (document.body.classList.contains('scrollLock')) koniec(); });
    obsBody.observe(document.body, { attributes: true, attributeFilter: ['class'] });
    zegar = setTimeout(koniec, 5000);
  }, true);
})();